// import React, { useEffect,useCallback, useState,useRef } from "react";
// import { Routes, Route, useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import { useMobileOrientation } from 'react-device-detect';
// import "bootstrap/dist/css/bootstrap.min.css";
// import { Row, Container, Col, Button, ListGroup, Form } from "react-bootstrap";
// import { useSelector,useDispatch } from "react-redux";
// import QRCode from "react-qr-code";
// import { ThreeDot } from "react-loading-indicators";
// import "../../style/Host.css";
// import { Box, LinearProgress } from "@mui/material";
// import noloop from "../../image/musicModal/noloop2.png";
// import { setVolume,setPlaying,setLoop,setCode  } from '../../Redux/action';
// import { ReactComponent as PlayMusicIcon } from "../../image/musicModal/playmusicicon.svg"; // Ensure correct casing
// import { ReactComponent as StopMusicIcon } from "../../image/stop_music_icon.svg";
// import firebase from '../../firebase';
// import copy from '../../image/copy.png';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css'; 
// import { QRCodeSVG } from 'qrcode.react';
// import landscapeIcon from '../../image/landscape-icon.webp';


// export default function Host({onNavigate}) {
//   const dispatch = useDispatch();
//   const { orientation } = useMobileOrientation();
//   const backgroundImg = useSelector(
//     (state) => state.backgroundImg.backgroundImg
//   );
//   const backgroundColor = useSelector(
//     (state) => state.backgroundColor.backgroundColor
//   );
//   const gameName = useSelector((state) => state.gameName.gameName);
//   const logo = useSelector((state) => state.logo.logo);
//   const rounds = useSelector((state) => state.round.rounds);
//   // console.log(rounds,"round");
//   const teamNames = useSelector(state => state.gameSettings.teamNames);
//   const buttonColor = useSelector((state) => state.gameSettings.buttonColor);
//   const progress = useSelector((state) => state.audio.progress);
//   const volume = useSelector((state) => state.audio.volume);
//   const playing = useSelector((state) => state.audio.playing);
//   const audio = useSelector((state) => state.audio.audio);
//   const loop = useSelector((state) => state.audio.loop);
//   const mobile = useSelector(state => state.mobile.isMobile); // Correctly access isMobile
//   const fontfamily = useSelector((state) => state.gameSettings.fontfamily);
//   const [selectedStudent, setSelectedStudent] = useState(null); 
//    const [positions, setPositions] = useState([]);
//   const [students, setStudents] = useState([]);
//   const [connectedStudent, setconnectedStudent] = useState([]);
//   const { clid :clid } = useParams();
//     const [copySuccess, setCopySuccess] = useState('');
//     const [showQrModal, setShowQrModal] = useState(false);
//   // console.log(clid,"clid");
//      const localization = useSelector((state) => state.localization.localization);
//   const backgroundStyle = backgroundImg
//   ? {
//       backgroundImage: `url(${backgroundImg})`,
//       backgroundSize: 'cover',
//       backgroundPosition: 'center',
//       paddingLeft: mobile ? '15px' : '0', // 15px if mobile is true, 0 otherwise
//       paddingRight: mobile ? '15px' : '0', // 15px if mobile is true, 0 otherwise
//     }
//   : {
//       backgroundColor,
//       paddingLeft: mobile ? '15px' : '0', // 15px if mobile is true, 0 otherwise
//       paddingRight: mobile ? '15px' : '0', // 15px if mobile is true, 0 otherwise
//     };
//     const team1bgColor = useSelector(state => state.gameSettings.team1bgColor);
//     const team2bgColor = useSelector(state => state.gameSettings.team2bgColor);
//   const [code, setCode] = useState(null);
//   const [codeSet, setCodeSet] = useState(false); 
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [data, setData] = useState(null);
// localStorage.setItem("code",code);
// const [hoveredParticipant, setHoveredParticipant] = useState(null);
// // Add this near your other useState hooks:
// const [searchTerm, setSearchTerm] = useState("");
//  const contentSectionRef = useRef(null);
//   const [participants, setParticipants] = useState([]);
//     const [locked, setLocked] = useState(true);
//   const [showInstructions, setShowInstructions] = useState(false);
//   const [showParticipants, setShowParticipants] = useState(false);
//   const [connectedStudentsforcrs, setconnectedStudentsforcr] = useState([]);
//   const [isportrait,setIsportrait] = useState(false);
//   const fullPath = window.location.pathname;
//   const isCLParamPresent = fullPath.includes("m=cl");
//   const [showStartTooltip, setShowStartTooltip] = useState(false);

//   // console.log("Is m=cl present:", isCLParamPresent);

//   const tooltipStyles = {
//   position: 'absolute',
//   top: '-40px',
//   left: '50%',
//   transform: 'translateX(-50%)',
//   backgroundColor: '#222',
//   color: '#fff',
//   padding: '6px 14px',
//   borderRadius: '8px',
//   fontSize: '1rem',
//   whiteSpace: 'nowrap',
//   zIndex: 1000,
//   boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
// };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(
//           `https://trivia-maker-tv.firebaseio.com/AppleTV/${code}.json`
//         );
//         const data = response.data;
//         setData(data);
//         setconnectedStudentsforcr(data.teamNames);
//         // console.log("Data fetched with axios:", data);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };

//     if (code) {
//       fetchData();
//     }
//   }, [code]);

//   useEffect(() => {
//   const handleEscapeKey = (event) => {
//     if (event.key === 'Escape') {
//       // Close any open modal
//       if (showInstructions) {
//         setShowInstructions(false);
//       } else if (showParticipants) {
//         setShowParticipants(false);
//       } else if (showQrModal) {
//         setShowQrModal(false);
//       }
//     }
//   };

//   // Add event listener
//   document.addEventListener('keydown', handleEscapeKey);

//   // Cleanup function to remove event listener
//   return () => {
//     document.removeEventListener('keydown', handleEscapeKey);
//   };
// }, [showInstructions, showParticipants, showQrModal]);

//   useEffect(() => {
//     if (code) {
//       const db = firebase.database();
//       const ref = db.ref(`AppleTV/${code}`);
//       let previousData;
//       ref.on("value", (snapshot) => {
//         const data = snapshot.val();
//         if (data !== previousData) {
//           console.log("Data updated:", data);
//           previousData = data;

//           const teamParticipants = data !== null && 'teamNames' in data ? data.teamNames.map((team, index) => {
//             return {
//               initials: team.initials,
//               name: team.name,
//               profileColor: team.profileColor,
//               allocatedTeam: team.allocatedTeam,
//             };
//           }) : [];
//           setParticipants(teamParticipants);
//         }
//       });
//     }
//   }, [code]);
//   useEffect(() => {
//     if (orientation === 'portrait') {
//       // User is on a mobile device in portrait mode
//       setIsportrait(true);
//       console.log("Mobile portrait mode detected");
//     } else {
//       setIsportrait(false);
//       console.log("Not mobile portrait mode");
//     }
//   }, [orientation]);
// const filteredParticipants = participants.filter(
//   participant =>
//     participant.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     participant.initials.toLowerCase().includes(searchTerm.toLowerCase())
// );
//   // Generate random positions for visible participants without overlap
// const generateRandomPositions = (count, avoidRect) => {
//   const positions = [];
//   const containerWidth = window.innerWidth;
//   const containerHeight = window.innerHeight;

//   const isOverlapping = (x, y) => {
//     // Check overlap with other bubbles
//     const overlapBubble = positions.some(pos => {
//       const dx = parseFloat(pos.left) - x;
//       const dy = parseFloat(pos.top) - y;
//       return Math.sqrt(dx * dx + dy * dy) < 10;
//     });
//     // Check overlap with avoidRect (content-section)
//     if (avoidRect) {
//       // Convert % to px for comparison
//       const leftPx = (x / 100) * containerWidth;
//       const topPx = (y / 100) * containerHeight;
//       if (
//         leftPx > avoidRect.left &&
//         leftPx < avoidRect.right &&
//         topPx > avoidRect.top &&
//         topPx < avoidRect.bottom
//       ) {
//         return true;
//       }
//     }
//     return overlapBubble;
//   };

//   for (let i = 0; i < count; i++) {
//     let x, y, tries = 0;
//     do {
//       x = Math.random() * 80 + 10; // 10% to 90%
//       y = Math.random() * 70 + 10; // 10% to 80%
//       tries++;
//       if (tries > 200) break; // Prevent infinite loop
//     } while (isOverlapping(x, y));
//     positions.push({
//       left: `${x}%`,
//       top: `${y}%`,
//     });
//   }
//   return positions;
// };

// useEffect(() => {
//   if (contentSectionRef.current) {
//     const rect = contentSectionRef.current.getBoundingClientRect();
//     setPositions(generateRandomPositions(participants.length, rect));
//   }
//   // Recalculate on window resize as well
//   const handleResize = () => {
//     if (contentSectionRef.current) {
//       const rect = contentSectionRef.current.getBoundingClientRect();
//       setPositions(generateRandomPositions(participants.length, rect));
//     }
//   };
//   window.addEventListener('resize', handleResize);
//   return () => window.removeEventListener('resize', handleResize);
// }, [participants.length, contentSectionRef.current]);
// // const handleStart = async () => {
// //   if (code) {
// //     try {
// //       const response = await axios.patch(
// //         `https://trivia-maker-tv.firebaseio.com/AppleTV/${code}.json`,
// //         {
// //           isParticipantGameStarted: true,          
// //         }
// //       );
// //       console.log("Game started successfully:", response);
// //       onNavigate('splash');
// //     } catch (error) {
// //       console.error("Error starting game:", error);
// //     }
// //   }
// // };

// // // final
// // const handleStart = async () => {
// //   // Extract the URL path and query parameters
// //   const urlParams = new URLSearchParams(window.location.search);
// //   let mParam = urlParams.get("m");

// //   // Fallback to extracting `m` from the pathname if not found in query params
// //   if (!mParam) {
// //     const pathSegments = window.location.pathname.split("/");
// //     const mSegment = pathSegments.find((segment) => segment.startsWith("m="));
// //     mParam = mSegment ? mSegment.split("=")[1] : null;
// //   }

// //   if (code) {
// //     try {
// //       // Update isParticipantGameStarted
// //       const gameResponse = await axios.patch(
// //         `https://trivia-maker-tv.firebaseio.com/AppleTV/${code}.json`,
// //         {
// //           isParticipantGameStarted: true,
// //         }
// //       );
// //       console.log("Game started successfully:", gameResponse);

// //       // If m=cl, handle ClassroomLeaderboard data
// //       if (mParam === "cl") {
// //         const clid = window.location.pathname.split("/").pop(); // Extract clid from URL
// //         const timestamp = Date.now(); // Get current timestamp in milliseconds
// //         const totalQuestions = rounds.length;

// //         // Create connectedstudents array
// //         const connectedStudents = participants.map((participant) => {
// //           return `${participant.initials} ${participant.profileColor} - ${participant.name}&%$@${participant.allocatedTeam}`;         
// //         });

// //         // Fetch the current data for the clid
// //         const currentDataResponse = await axios.get(
// //           `https://trivia-maker.firebaseio.com/ClassroomLeaderboard/${clid}.json`
// //         );
// //         const currentData = currentDataResponse.data;

// //         // Ensure currentData is an array
// //         const dataArray = Array.isArray(currentData) ? currentData : [];

// //         // Add new session data
// //         const newSession = {
// //           gametype: "hangman",
// //           name: gameName, // Ensure gameName is defined
// //           date: timestamp, // Set the date as a timestamp
// //           starttime: timestamp, // Set the start time as a timestamp
// //           totalquestions: totalQuestions,
// //           connectedstudents: connectedStudents, // Set connectedstudents array
// //           scores: [],
// //           questionsarray:[],
// //           particiantsanswers:[],
// //         };

// //         // Append the new session to the existing array
// //         const updatedData = [...dataArray, newSession];

// //         // Update the ClassroomLeaderboard with the new array
// //         const leaderboardResponse = await axios.put(
// //           `https://trivia-maker.firebaseio.com/ClassroomLeaderboard/${clid}.json`,
// //           updatedData
// //         );
// //         console.log(
// //           "Leaderboard data updated successfully:",
// //           leaderboardResponse.data
// //         );
// //       }

// //       // Navigate to splash screen
// //       onNavigate("splash");
// //     } catch (error) {
// //       console.error("Error in handleStart:", error);
// //     }
// //   }
// // };


// // final after classroom export result
// // const handleStart = async () => {
// //   // Extract the URL path and query parameters
// //   const urlParams = new URLSearchParams(window.location.search);
// //   let mParam = urlParams.get("m");

// //   // Fallback to extracting `m` from the pathname if not found in query params
// //   if (!mParam) {
// //     const pathSegments = window.location.pathname.split("/");
// //     const mSegment = pathSegments.find((segment) => segment.startsWith("m="));
// //     mParam = mSegment ? mSegment.split("=")[1] : null;
// //   }

// //   if (code) {
// //     try {
// //       // Update isParticipantGameStarted
// //       const gameResponse = await axios.patch(
// //         `https://trivia-maker-tv.firebaseio.com/AppleTV/${code}.json`,
// //         {
// //           isParticipantGameStarted: true,
// //         }
// //       );
// //       console.log("Game started successfully:", gameResponse);

// //       // If m=cl, handle ClassroomLeaderboard data
// //       if (mParam === "cl") {
// //         const clid = window.location.pathname.split("/").pop(); // Extract clid from URL
// //         const timestamp = Date.now(); // Get current timestamp in milliseconds
// //         const totalQuestions = rounds.length;

// //         // Create connectedstudents array
// //         const connectedStudents = participants.map((participant) => {
// //           return `${participant.initials} ${participant.profileColor} - ${participant.name}&%$@${participant.allocatedTeam}`;         
// //         });

// //         // Fetch the current data for the clid
// //         const currentDataResponse = await axios.get(
// //           `https://trivia-maker.firebaseio.com/ClassroomLeaderboard/${clid}.json`
// //         );
// //         const currentData = currentDataResponse.data;


// //         const currentDataResponseforclassroom = await axios.get(
// //           `https://trivia-maker.firebaseio.com/Classroom/${clid}.json`
// //         );
// //         const currentDataforclassroom = currentDataResponseforclassroom.data;
// //         console.log(currentDataforclassroom, "currentDataforclassroom");

// //         // Ensure currentData is an array
// //         const dataArray = Array.isArray(currentData) ? currentData : [];
// //         const initialScores = students.map((student) => ({
// //           name: student.fullname, // The student name
// //           score: 0, // Initialize score to 0
// //           correctanswer: 0, // Initialize correctAnswers to 0
// //         }));

// //         // Add new session data with additional activity details
// //         const newSession = {
// //           gametype: "hangman",
// //           name: gameName, // Ensure gameName is defined
// //           date: Math.floor(timestamp / 1000), // Set the date as a timestamp
// //           startime: timestamp, // Set the start time as a timestamp
// //           totalquestions: totalQuestions,
// //           connectedstudents: connectedStudents, // Set connectedstudents array
// //           scores: initialScores,
// //           questionsarray: [],
// //           particiantsanswers: [],
// //         };

// //         // Add activity details (status and time)
// //         const newActivity = {
// //           status: `${gameName} Started`,
// //           time: timestamp, // Time set to match starttime
// //         };

// //         // Add the new activity to the Activities array
// //         if (currentDataforclassroom && currentDataforclassroom.Activities) {
// //           currentDataforclassroom.Activities.push(newActivity);
// //         } else {
// //           currentDataforclassroom.Activities = [newActivity];
// //         }


// //         // Add new session and updated activity to ClassroomLeaderboard
// //         const updatedData = [...dataArray, newSession];

// //         const sessionData = Array.isArray(currentData) ? currentData : [];
// //         const currentSession = sessionData[sessionData.length - 1];

// //         if (currentSession && Array.isArray(currentSession.connectedstudents)) {
// //           // Extract values before the '&' symbol
// //           const extractedStudents = currentSession.connectedstudents.map((student) =>
// //             student.split("&")[0] // Get the part before '&'
// //           );

// //           setconnectedStudent(extractedStudents); // Update state with extracted values
// //           console.log("Connected students:", extractedStudents); // Log the extracted values
// //         } else {
// //           console.error(
// //             "connectedstudents is not an array or is missing:",
// //             currentSession.connectedstudents
// //           );
// //           setconnectedStudent([]); // Set an empty array to avoid breaking downstream logic
// //         }


// //         // Update ClassroomLeaderboard with the new session and activity
// //         await axios.put(
// //           `https://trivia-maker.firebaseio.com/ClassroomLeaderboard/${clid}.json`,
// //           updatedData
// //         );

// //         // Update the Classroom data with the new activities
// //         await axios.put(
// //           `https://trivia-maker.firebaseio.com/Classroom/${clid}.json`,
// //           currentDataforclassroom
// //         );

// //         console.log("Leaderboard data and activity updated successfully.");
// //       }

// //       // Navigate to splash screen
// //       onNavigate("splash");
// //     } catch (error) {
// //       console.error("Error in handleStart:", error);
// //     }
// //   }
// // };

// const handleStart = async () => {
//   // Extract the URL path and query parameters
//   const urlParams = new URLSearchParams(window.location.search);
//   let mParam = urlParams.get("m");
//   let putData = {}; // Initialize putData here to avoid undefined errors

//   // Fallback to extracting `m` from the pathname if not found in query params
//   if (!mParam) {
//     const pathSegments = window.location.pathname.split("/");
//     const mSegment = pathSegments.find((segment) => segment.startsWith("m="));
//     mParam = mSegment ? mSegment.split("=")[1] : null;
//   }

//   if (code) {
//     try {
//       // Update isParticipantGameStarted
//       if (mParam === "cl") {
//         const clid = window.location.pathname.split("/").pop(); // Extract clid from URL
//         const timestamp = Date.now(); // Get current timestamp in milliseconds
//         const totalQuestions = rounds.length;

//         // Create connectedstudents array
//         const connectedStudents = participants.map((participant) => {
//           return `${participant.initials} ${participant.profileColor} - ${participant.name}&%$@${participant.allocatedTeam}`;
//         });

//         // Fetch the current data for the clid
//         const currentDataResponse = await axios.get(
//           `https://trivia-maker.firebaseio.com/ClassroomLeaderboard/${clid}.json`
//         );
//         const currentData = currentDataResponse.data || []; // Default to empty array if no data

//         // Fetch classroom data
//         const currentDataResponseforclassroom = await axios.get(
//           `https://trivia-maker.firebaseio.com/Classroom/${clid}.json`
//         );
//         const currentDataforclassroom = currentDataResponseforclassroom.data || {};

//         // Initialize scores
//         const initialScores = students.map((student) => ({
//           name: student.fullname,
//           score: 0,
//           correctanswer: 0,
//         }));

//         // Add new session and activity data
//         const newSession = {
//           gametype: "hangman",
//           name: gameName,
//           date: Math.floor(timestamp / 1000),
//           startime: timestamp,
//           totalquestions: totalQuestions,
//           connectedstudents: connectedStudents,
//           scores: initialScores,
//           questionsarray: [],
//           particiantsanswers: [],
//         };

//         const newActivity = {
//           status: `${gameName} Started`,
//           time: timestamp,
//         };

//         // Add activity to the classroom data
//         if (currentDataforclassroom.Activities) {
//           currentDataforclassroom.Activities.push(newActivity);
//         } else {
//           currentDataforclassroom.Activities = [newActivity];
//         }

//         // Update ClassroomLeaderboard
//         const updatedData = [...currentData, newSession];

//         // Update Firebase ClassroomLeaderboard
//         await axios.put(
//           `https://trivia-maker.firebaseio.com/ClassroomLeaderboard/${clid}.json`,
//           updatedData
//         );
//         await axios.put(
//           `https://trivia-maker.firebaseio.com/Classroom/${clid}.json`,
//           currentDataforclassroom
//         );

//         console.log("Leaderboard data and activity updated successfully.");
//       }

//       if (mParam === "cr") {
//         try {
//             const timestamp = Date.now();
//             const totalQuestions = rounds.length;

//             // Create connectedstudents array
//             const connectedStudents = participants.map((participant) => {
//                 return `${participant.initials} ${participant.profileColor} - ${participant.name}&%$@${participant.allocatedTeam}`;
//             });

//             // Initialize scores
//             const initialScores = participants.map((participant) => ({
//                 name: `${participant.initials} ${participant.profileColor} - ${participant.name}`,
//                 score: 0,
//                 correctanswer: 0,
//             }));

//             const crowdDataEntry = {
//                 gametype: "hangman",
//                 name: gameName,
//                 date: Math.floor(timestamp / 1000),
//                 startime: timestamp,
//                 totalquestions: totalQuestions,
//                 connectedstudents: connectedStudents,
//                 scores: initialScores,
//                 questionsarray: [],
//                 particiantsanswers: [],
//             };

//             // Directly update the crowd array in the request payload
//             const gameResponse = await axios.patch(
//                 `https://trivia-maker-tv.firebaseio.com/AppleTV/${code}.json`,
//                 {
//                     isParticipantGameStarted: true,
//                     crowd: [...(putData.crowd || []), crowdDataEntry], // Directly set the crowd array
//                 }
//             );

//             if (gameResponse.status === 200) {
//                 console.log("Crowd data updated successfully.");
//             } else {
//                 console.error("Failed to update crowd data:", gameResponse);
//             }
//         } catch (error) {
//             console.error("Error in setting crowd data:", error);
//         }
//     }

//       // Navigate to splash screen
//       onNavigate("splash");
//     } catch (error) {
//       console.error("Error in handleStart:", error);
//     }
//   }
// };
// const participantZones = [
//   'zone-top-left',
//   'zone-top-right',
//   'zone-mid-left',
//   'zone-mid-right',
//   'zone-bottom-left',
//   'zone-bottom-right'
// ];
//   const toggleInstructionsModal = () => setShowInstructions(v => !v);
//   const toggleParticipantsList = () => setShowParticipants(v => !v);
//   const toggleLock = () => setLocked(l => !l);
// const formatDate = (date) => {  
//   const yyyy = date.getFullYear();
//   const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
//   const dd = String(date.getDate()).padStart(2, '0');
//   return `${yyyy}/${mm}/${dd}`; // Return in yyyy-mm-dd format
// };

// const fetchGameData = async () => {
//   try {
//     // Fetch initial game data from Firebase
//     const response = await fetch(`https://trivia-maker-tv.firebaseio.com/AppleTV/${code}.json`);
//     if (!response.ok) {
//       throw new Error(`Error fetching data: ${response.statusText}`);
//     }
//     const data = await response.json();
//     // setGameData(data);

//     // Listen for changes in the students data from Firebase Realtime Database
//     const db = firebase.database();
//     const ref = db.ref(`AppleTV/${code}/students`);

//     // Handle the initial fetch and subsequent updates
//     ref.on('value', snapshot => {
//       const students = snapshot.val();
//       if (Array.isArray(students)) {
//         const dynamicStudents = students.map((student, index) => {
//           const parts = student.stuname.split(" - ");
//           const color = parts[0].split(" ")[1] || "gray";
//           const initials = parts[0].split(" ")[0] || "??";
//           const name = parts[1] || "Unknown";
//           const textColor = color.toLowerCase() === "white" ? "black" : "white";
//           const fullname = student.stuname
//           return {
//             id: student.stuid || index,
//             color,
//             initials,
//             name,
//             textColor,
//             fullname,
//             correctAnswers: student.correctanswers || 0,
//             gamesPlayed: student.gameplayed || 0,
//             questionsAttempted: student.questionattempted || 0,
//             email: student.stuemail || "N/A",
//             stupin: student.stupin || "",
//           };
//         });

//         setStudents(dynamicStudents);
//       } else {
//         console.error("Invalid or missing students data:", students);
//         setStudents([]);
//       }
//     });

//   } catch (err) {
//     console.error("Error fetching game data:", err);
//     setError(err.message);
//   } 
// };

// useEffect(() => {
//   // Fetch game data on component mount
//   fetchGameData();

//   // Cleanup function to remove the Firebase listener when the component unmounts
//   return () => {
//     const db = firebase.database();
//     const ref = db.ref(`AppleTV/${code}/students`);
//     ref.off(); // This will remove the listener
//   };
// }, [code]); 

// // const generateAndCheckCode = async () => {
// //   setIsLoading(true); // Start loading
// //   setError(null); // Reset error state

// //   try {
// //     const currentUrl = window.location.href; // Get the current URL
// //     let randomCode;
// //     let additionalData = null; // Initialize additional data

// //     if (currentUrl.includes("m=cl")) {
// //       const idMatch = currentUrl.match(/CL\d+/); // Extract the dynamic ID
// //       const dynamicId = idMatch ? idMatch[0] : null;
// //       console.log(dynamicId, "dynamicId"); // Log the dynamic ID

// //       if (dynamicId) {
// //         const apiResponse = await axios.get(
// //           `https://trivia-maker.firebaseio.com/Classroom/${dynamicId}.json`
// //         );
// //         console.log(apiResponse.data, "apiResponse.data"); // Log the full response

// //         if (apiResponse.data) {
// //           const slug = apiResponse.data["url-slug"];
// //           const students = apiResponse.data["students"]; // Extract dynamic student data
// //           console.log(students, "Students from API");

// //           if (slug) {
// //             randomCode = slug; // Use the url-slug as the random code
// //             console.log(randomCode, "Random code from url-slug");

// //             // Add additional data when slug is used
// //             additionalData = {
// //               students: students || [], // Include students dynamically or use an empty array
// //             };
// //           } else {
// //             console.error("url-slug is missing or null in the response");
// //             throw new Error("Invalid API response: missing 'url-slug'");
// //           }
// //         } else {
// //           throw new Error("API response data is null or undefined");
// //         }
// //       } else {
// //         throw new Error("Dynamic ID not found in URL");
// //       }
// //     } else {
// //       randomCode = Math.floor(100000 + Math.random() * 900000);
// //       console.log(randomCode, "Random code generated");
// //     }

// //     // Build the data object dynamically
// //     const putData = {
// //       appStatus: true,
// //       gameName: gameName,
// //       gametype: "HangMan",
// //       logo: logo,
// //       teams: teamNames,
// //       backgroundImg: backgroundImg,
// //       backgroundColor: backgroundColor,
// //       team1bgColor: team1bgColor,
// //       team2bgColor: team2bgColor,
// //       date: formatDate(new Date()),
// //       fontfamily: fontfamily,
// //       ...(additionalData ? additionalData : {}),
// //        // Include additional data if available
// //     };

// //     // Always overwrite the existing data by sending a PUT request
// //     const putResponse = await axios.put(
// //       `https://trivia-maker-tv.firebaseio.com/AppleTV/${randomCode}.json`,
// //       putData
// //     );

// //     if (putResponse.status === 200) {
// //       console.log("Data successfully updated in Firebase");
// //       dispatch(setCode(randomCode)); // Dispatch the setCode action
// //       console.log(randomCode, "Code dispatched to Redux");
// //     } else {
// //       console.error("Failed to update data in Firebase");
// //       throw new Error("Failed to save data");
// //     }
// //   } catch (error) {
// //     console.error("Error in generateAndCheckCode:", error);
// //     setError(error.message);
// //   } finally {
// //     setIsLoading(false); // Stop loading after the process completes
// //   }
// // };

// let participantLimit = 20;

// let userid = ""; 

// const generateAndCheckCode = async () => {
//   setIsLoading(true); // Start loading
//   setError(null); // Reset error state

//   try {
//     const currentUrl = window.location.href; // Get the current URL
//     let randomCode;
//     let additionalData = null; // Initialize additional data
//     let crowddata = [];


//     // Check if the URL contains m=cl
//     if (currentUrl.includes("m=cl")) {
//       const idMatch = currentUrl.match(/CL\d+/); // Extract the dynamic ID
//       const dynamicId = idMatch ? idMatch[0] : null;
//       console.log(dynamicId, "dynamicId");

//       if (dynamicId) {
//         const apiResponse = await axios.get(
//           `https://trivia-maker.firebaseio.com/Classroom/${dynamicId}.json`
//         );
//         console.log(apiResponse.data, "apiResponse.data");

//         if (apiResponse.data) {
//           const slug = apiResponse.data["url-slug"];
//           const students = apiResponse.data["students"]; // Extract student data
//           console.log(students, "Students from API");

//           if (slug) {
//             randomCode = slug; // Use the url-slug as the random code
//             console.log(randomCode, "Random code from url-slug");

//             additionalData = {
//               students: students || [],
//             };
//           } else {
//             console.error("url-slug is missing or null in the response");
//             throw new Error("Invalid API response: missing 'url-slug'");
//           }
//         } else {
//           throw new Error("API response data is null or undefined");
//         }
//       } else {
//         throw new Error("Dynamic ID not found in URL");
//       }
//     } else {
//       randomCode = Math.floor(100000 + Math.random() * 900000);
//       console.log(randomCode, "Random code generated");
//     }
//      try {
//   // Get userid from login API
//   const loginResponse = await fetch("https://triviamaker.com/checklogin.php");
//   if (loginResponse.ok) {
//     userid = (await loginResponse.text()).trim();
//   }

//   // Firebase setup
//  const defaultDatabase = firebase.initializeApp({
//   databaseURL: "https://trivia-maker.firebaseio.com/"
// }, "triviaMakerApp").database();
//   const triviaRef = defaultDatabase.ref(`TMUsers/${userid}/Teams`);
//   const teamsSnapshot = await triviaRef.once('value');
//   const teamsData = teamsSnapshot.val();

//   if (teamsData && Array.isArray(teamsData) && teamsData.length > 0) {
//     // Corporate logic
//     const corporateId = teamsData[0];
//     const corpResponse = await fetch(`https://trivia-maker-corporate.firebaseio.com/corporates/${corporateId}/profile/planUserCount.json`);
//     const planUserCount = await corpResponse.json();

//     if (planUserCount === -1) {
//       participantLimit = 200;
//     } else if (planUserCount <= 5) {
//       participantLimit = 100;
//     } else if (planUserCount <= 10) {
//       participantLimit = 500;
//     } else if (planUserCount <= 20) {
//       participantLimit = 1000;
//     } else if (planUserCount <= 50) {
//       participantLimit = 2000;
//     } else if (planUserCount <= 500) {
//       participantLimit = 500;
//     } else {
//       participantLimit = 20; // fallback
//     }
//     console.log("Corporate planUserCount:", planUserCount, "Participant limit set to:", participantLimit);
//   } else {
//     // Subscription fallback logic
//     const subResponse = await axios.get(`https://triviamaker.com/Subscription/checkSubscription.php?userid=${userid}`);
//     console.log("Subscription API response:", subResponse.data);

//     switch (subResponse.data.type) {
//       case "Premium Plus":
//         participantLimit = 200;
//         break;
//       case "Lifetime":
//       case "Premium":
//         participantLimit = 50;
//         break;
//       case "null":
//       default:
//         participantLimit = 20;
//         break;
//     }
//   }
// } catch (error) {
//   console.error("Error determining participant limit:", error);
//   participantLimit = 20; // fallback
// }
//     const putData = {
//       appStatus: true,
//       gameName: gameName,
//       gametype: "HangMan",
//       logo: logo,
//       teams: teamNames,
//       backgroundImg: backgroundImg,
//       backgroundColor: backgroundColor,
//       team1bgColor: team1bgColor,
//       team2bgColor: team2bgColor,
//       date: formatDate(new Date()),
//       fontfamily: fontfamily,
//       participantlimit: participantLimit,
//       ...(additionalData ? additionalData : {}),
//     };

//     console.log("Data to be sent:", putData);

//     const putResponse = await axios.put(
//       `https://trivia-maker-tv.firebaseio.com/AppleTV/${randomCode}.json`,
//       putData
//     );

//     if (putResponse.status === 200) {
//       console.log("Data successfully updated in Firebase");
//       dispatch(setCode(randomCode)); // Dispatch the setCode action
//       console.log(randomCode, "Code dispatched to Redux");
//     } else {
//       console.error("Failed to update data in Firebase", putResponse);
//       throw new Error("Failed to save data");
//     }
//   } catch (error) {
//     console.error("Error in generateAndCheckCode:", error);
//     setError(error.message);
//   } finally {
//     setIsLoading(false); // Stop loading after the process completes
//   }
// };


// useEffect(() => {
//   if (backgroundStyle && !code) {
//     generateAndCheckCode();
//   }
// }, [gameName, logo, teamNames]);



// const copyToClipboard = async (text) => {
//   try {
//     // First try using the Clipboard API
//     if (navigator.clipboard && navigator.clipboard.writeText) {
//       await navigator.clipboard.writeText(text);
//       setCopySuccess('Copied!');
//       setTimeout(() => setCopySuccess(''), 2000);
//     } else {
//       // Fallback method using a temporary textarea element
//       const textArea = document.createElement('textarea');
//       textArea.value = text;

//       // Make the textarea out of viewport
//       textArea.style.position = 'fixed';
//       textArea.style.left = '-999999px';
//       textArea.style.top = '-999999px';
//       document.body.appendChild(textArea);

//       // Select and copy
//       textArea.focus();
//       textArea.select();

//       const successful = document.execCommand('copy');
//       document.body.removeChild(textArea);

//       if (successful) {
//         setCopySuccess('Copied!');
//         setTimeout(() => setCopySuccess(''), 2000);
//       } else {
//         throw new Error('Copy failed');
//       }
//     }
//   } catch (err) {
//     console.error('Failed to copy text: ', err);
//     // Show error message to user
//     setCopySuccess('Copy failed. Please try again.');
//     setTimeout(() => setCopySuccess(''), 2000);
//   }
// };




//   // Function to group participants into columns of 10
//   const screenWidth = window.screen.width;
//   const screenHeight = window.screen.height;

//   function getResolution(width, height) {
//     if (width >= 3840 && height >= 2160) {
//       return "4K";
//     } else if (width >= 2560 && height >= 1440) {
//       return "2K";
//     } else if (width >= 1280 && height >= 720) {
//       return "HD";
//     } else {
//       return "SD";
//     }
//   }

//   // General function to detect any mobile device
//   function isMobileDevice() {
//     const userAgent = window.navigator.userAgent.toLowerCase();
//     return /android|iphone|ipad|ipod/.test(userAgent); // Detect Android and iOS devices
//   }

//   // Check if the device is in landscape mode
//   function isLandscapeMode() {
//     return window.innerWidth > window.innerHeight;
//   }

//   const groupParticipants = (participants, groupSize) => {
//     const groups = [];
//     for (let i = 0; i < participants.length; i += groupSize) {
//       groups.push(participants.slice(i, i + groupSize));
//     }
//     return groups;
//   };
//   window.addEventListener("resize", getResolution);
//   // Get screen resolution
//   const resolution = getResolution(screenWidth, screenHeight);

//   // Set participant group size based on resolution or device
//   let groupSize;
//   if (isMobileDevice() && isLandscapeMode()) {
//     groupSize = 2; // Set 5 participants for all mobile devices in landscape mode
//   } else if (resolution === "4K" || resolution === "2K") {
//     groupSize = 10;
//   } else if (resolution === "HD") {
//     groupSize = 10;
//   } else {
//     groupSize = 6; // Default for SD or other
//   }

//   // Assume participants array

//   const participantGroups = groupParticipants(participants, groupSize);

//   // console.log(`Screen Resolution: ${resolution}`);
//   // console.log(`Group Size: ${groupSize}`);
//   // console.log("Grouped Participants:", participantGroups);



//   function lightenColor(color, percent) {
//     const num = parseInt(color.replace("#", ""), 16);
//     const amt = Math.round(2.55 * percent);
//     const R = (num >> 16) + amt;
//     const G = ((num >> 8) & 0x00ff) + amt;
//     const B = (num & 0x0000ff) + amt;

//     return (
//       "#" +
//       (
//         0x1000000 +
//         (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
//         (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
//         (B < 255 ? (B < 1 ? 0 : B) : 255)
//       )
//         .toString(16)
//         .slice(1)
//     );
//   }

//   const lighterButtonColor = lightenColor(buttonColor, 30);



//   // music content
//   const handleLoopToggle = () => {
//     const newLoopState = !loop;
//     dispatch(setLoop(newLoopState));  // Toggle the loop state
//     audio.loop = newLoopState;        // Set the audio element's loop property
//   };

//   const handlePlay = useCallback(() => {
//     console.log("handlePlay called");
//     audio?.play();
//     dispatch(setPlaying(true));
//   }, [audio, dispatch]);

//   const handlePause = useCallback(() => {
//     console.log("handlePause called");
//     if (audio && !audio.paused) {
//         audio.pause();
//         dispatch(setPlaying(false));
//         console.log("Audio paused");
//     } else {
//         console.log("Audio is already paused or not defined.");
//     }
// }, [audio, dispatch]);

//   const increaseVolume = () => {
//     if (volume < 100) {
//       dispatch(setVolume(volume + 10)); // Increase volume by 10
//     }
//   };
//   const decreaseVolume = () => {
//     if (volume > 0) {
//       dispatch(setVolume(volume - 10)); // Decrease volume by 10
//     }
//   };

//   const handleCopyCode = () => {
//     if (navigator.clipboard && navigator.clipboard.writeText) {
//       navigator.clipboard.writeText(`${code}`)
//         .then(() => {
//           toast('Code copied to clipboard!'); // Show success toast
//         })
//         .catch((err) => {
//           console.error('Failed to copy: ', err);
//           toast.error('Failed to copy code.'); // Show error toast if copy fails
//         });
//     } else {
//       fallbackCopyTextToClipboard(code);
//     }
//   };

//   const handleCopyLink = () => {
//     // Extract URL as a string
//     const url = isCLParamPresent
//       ? `https://triviamaker.com/student/${code}`
//       : `https://play.triviamaker.com/hangman/?p=${code}`;

//     // Use clipboard API to copy the text
//     if (navigator.clipboard && navigator.clipboard.writeText) {
//       navigator.clipboard.writeText(url)
//         .then(() => {
//           toast('Link copied to clipboard!'); // Show success toast
//           console.log(`Copied URL: ${url}`); // Log copied URL for debugging
//         })
//         .catch((err) => {
//           console.error('Failed to copy: ', err);
//           toast.error('Failed to copy link.'); // Show error toast if copy fails
//         });
//     } else {
//       fallbackCopyTextToClipboard(url); // Fallback for older browsers
//     }
//   };

//   // Fallback function for browsers that do not support navigator.clipboard
//   const fallbackCopyTextToClipboard = (text) => {
//     const textArea = document.createElement("textarea");
//     textArea.value = text;
//     document.body.appendChild(textArea);
//     textArea.select();
//     try {
//       document.execCommand('copy');
//       toast('Link copied to clipboard!'); // Show success toast
//       console.log(`Copied URL (fallback): ${text}`); // Log copied URL for debugging
//     } catch (err) {
//       console.error('Fallback: Failed to copy', err);
//       toast.error('Failed to copy text.'); // Show error toast if fallback fails
//     }
//     document.body.removeChild(textArea);
//   };

//   return (
//     <>
//     {isportrait ? (
//       <>
//     <div 
//       style={{
//         justifyContent: 'center',
//         alignItems: 'center',
//         height: '100vh',
//         fontSize: '1.5rem',
//         fontWeight:'bolder',
//         backgroundColor:'#27738e',
//         color: 'white',
//         display:'flex',
//         flexDirection:'column',
//         padding: '1.5vh'
//       }}
//     >
//       <span className='mt-2 mb-4 p-3 '> To view this game, you will need to place your device in landscape mode</span>

//       <div style={{padding:'1.5vh'}}>
//       <img src={landscapeIcon} alt="landscapeIcon" height={200} className="rotate-icon" />
//       </div>
//     </div>
//     </>
//   ):(
// //     <>
// //     <div className="main" style={backgroundStyle}>
// //       <div className="child">
// //         <Row className="d-flex justify-content-center ">
// //           <Col xs={8} sm={8} md={8} lg={8} xl={9}>
// //             <div className="p-4 partition  ">
// //               <div className="d-flex align-items-center heading">
// //                 <img src={logo} alt="" className="logoImg" />
// //                 <div className="ms-4 ">
// //                   <p className="mb-2 about">We are about to play,</p>
// //                   <p className="gameName">
// //   {gameName.length > 30 ? `${gameName.substring(0, 30)}...` : gameName}
// // </p>

// //                 </div>
// //               </div>

// //               <Box
// //                 className="mb-4  players-container p-2"
// //                 style={{
// //                   boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.9)",
// //                   borderRadius: "8px",
// //                 }}
// //               >
// //                 <div className="mb-2 mt-3 p-2 d-flex align-items-center justify-content-between">
// //                   <p className="ms-2 me-2 incomingplayer">Incoming Players</p>
// //                   <p className="me-2 lengthText">
// //                     {participants.length} Participants are connected
// //                   </p>
// //                 </div>

// //                 {/* Participants list that scrolls horizontally */}
// //                 <div className="participants-list scroll">
// //                   <div className="participants-list ">
// //                     {participantGroups.map((group, groupIndex) => (
// //                       <div
// //                         key={groupIndex}
// //                         className="participant-column d-inline-block mr-3"
// //                       >
// //                         {group.map((participant, index) => (
// //                           <div
// //                             key={index}
// //                             className="participant-item d-flex justify-content-between align-items-center "
// //                           >
// //                             <div
// //                               className=" initials text-center "
// //                               style={{
// //                                 backgroundColor: participant.profileColor,
// //                               }}
// //                             >
// //                               {participant.initials}
// //                             </div>
// //                             <div className=" text-center participantName me-3">
// //                             {participant.name && (
// //     <>
// //       {/* Split the participant name into first and last names */}
// //       {(() => {

// //         const nameParts = participant.name.split(" ");

// //         // First name stays fully displayed
// //         const firstName = nameParts[0]; 

// //         // Truncate last name after 3 characters if it's longer than 3 characters
// //         const lastName = nameParts[1] && nameParts[1].length > 3 
// //           ? `${nameParts[1].slice(0, 3)}...` 
// //           : nameParts[1] || ""; 

// //         return `${firstName} ${lastName}`;
// //       })()}
// //     </>
// //   )}
// //                             </div>    
// //                           </div>
// //                         ))}
// //                       </div>
// //                     ))}
// //                   </div>
// //                 </div>
// //               </Box>
// //             </div>
// //           </Col>

// //           <Col xs={4} sm={4} md={4} lg={4} xl={3}>
// //             <div className="partition ToJoin shadow bg-white">
// //               <p className="mb-3  mt-2 toJoinText">To Join,</p>
// //               <div
// //   className="link d-flex"
// //   style={{ backgroundColor: lighterButtonColor,position: 'relative' }}
// // >
// // <p className="linkofgame">
// // {isLoading ? (
// //   <div className="ThreeDot">
// //     <ThreeDot
// //       color="black"
// //       size="medium"
// //       text=""
// //       textColor=""
// //     />
// //   </div>
// // ) : (
// //   <>
// //     {isCLParamPresent ? (
// //       <span>https://triviamaker.com/student/{code}</span>
// //     ) : (
// //       <span>https://triviamaker.com/h/{code}</span>
// //     )}
// //   </>
// // )}
// //   <ToastContainer />
// // </p>

// //   <img
// //     src={copy}
// //     alt="copy"
// //     className="copyImg"
// //     onClick={handleCopyLink}
// //     style={{ cursor: 'pointer',position: 'absolute',right:25 }} // Add a pointer cursor to indicate it's clickable
// //   />

// // </div>




// // {isCLParamPresent ? ( null
// // ) : (
// //   <Form.Group
// //     className="mb-3 EnterCode"
// //     style={{ backgroundColor: buttonColor, position: 'relative' }}
// //   >
// //     <p className="EnterCodeText">
// //       Enter Code
// //       <img
// //         src={copy}
// //         alt="copy"
// //         className="copyImgCode"
// //         onClick={handleCopyCode}
// //         style={{ cursor: 'pointer', position: 'absolute', right: 25, top: 20 }}
// //       />
// //     </p>

// //     {isLoading ? (
// //       <div className="ThreeDot">
// //         <ThreeDot color="black" size="medium" text="" textColor="" />
// //       </div>
// //     ) : (
// //       <p className="code">{code}</p>
// //     )}
// //   </Form.Group>
// // )}


// //               {/* Center QR Code using flexbox */}
// //               <div
// //                 className="d-flex justify-content-center  QrCode"
// //                 style={{ backgroundColor: buttonColor }}
// //               >
// //                 <div className="bg-white QRContainer ">
// //                 <QRCode
// //   className="bg-white QrValue p-1"
// //   value={isCLParamPresent ? 
// //     `https://triviamaker.com/student/${code}` : 
// //     `https://play.triviamaker.com/hangman/?p=${code}`} // Dynamic value for QR code
// // />


// //                 </div>
// //               </div>
// //               <div
// //   className="remaining-participant d-flex flex-column mt-1"
// //   style={{ backgroundColor: lighterButtonColor }}
// // >
// //   {isCLParamPresent ? (
// //     <>
// //       <span className="h4reaminingparticipant">Remaining Participants</span>
// //       <div
// //         className="d-flex flex-wrap remaining-participant-div gap-2 mt-1"
// //         style={{
// //     // Adjust height to fit one row
// //           overflowY: 'auto', // Enable vertical scrolling
// //         }}
// //       >
// //         {students.map((student) => (
// //           <div
// //             key={student.id}
// //             className="student-container-host"
// //             style={{ opacity: 1 }}
// //           >
// //             <div
// //               className="animal-circle-host active-user-border group-user-host"
// //               style={{
// //                 backgroundColor: student.color,
// //                 color: student.textColor,
// //                 cursor: 'pointer',
// //               }}
// //             >
// //               {student.initials}
// //             </div>
// //           </div>
// //         ))}
// //       </div>
// //     </>
// //   ) : null}
// // </div>


// //             </div>


// //             <div className="d-grid mt-2 m-2 mb-4 gap-2">
// //   {participants.length >= 2 && (
// //     <Button
// //       size="lg"
// //       className="startButton"
// //       onClick={handleStart}
// //       style={{ backgroundColor: buttonColor }}
// //     >
// //       Start
// //     </Button>
// //   )}
// // </div>

// //           </Col>
// //           <div className="musicdiv">
// //             <div className="bg-white musicContainer d-flex p-1">
// //               <div className="d-flex justify-content-start ">
// //                 <img src={noloop} alt="noloop" className="img me-2 "  onClick={handleLoopToggle}  />
// //               {playing?(   < StopMusicIcon
// //                   className="img playimg"
// //                   style={{ fill: buttonColor || "black" }}
// //                   onClick={handlePause}
// //                 />):(<PlayMusicIcon
// //                   className="img playimg"
// //                   style={{ fill: buttonColor || "black" }}
// //                   onClick={handlePlay}
// //                 />)}

// //               </div>
// //               <div className="ms-3 d-flex justify-content-center align-items-center">
// //                 <div className="me-2" onClick={decreaseVolume}>-</div>
// //                 <Form.Range
// //   value={progress}
// //   className="Hostclassrange me-2"
// //   max="100"
// //   style={{
// //     background: `linear-gradient(90deg, ${buttonColor} ${progress}%, ${lighterButtonColor} ${progress}%)`, // Apply gradient based on progress
// //     '--button-color': buttonColor, // Custom color for the slider thumb
// //     '--lighter-button-color': lighterButtonColor, // Custom color for the unfilled track
// //   }}
// // />

// //                 <div  onClick={increaseVolume} className="me-2">+</div>
// //               </div>
// //             </div>
// //           </div>
// //         </Row>
// //       </div>
// //     </div>
// //     </>
// <>
//     <div
//     className="animated-bg relative flex flex-col"
//     style={{
//       minHeight: '100vh',
//       height: '100dvh',
//       overflowY: 'auto',
//       overflowX: 'hidden',
//       WebkitOverflowScrolling: 'touch',
//     }}
//   >
//       {/* Floating Particles */}
//       <div className="floating-particle particle-1 text-white text-opacity-30 text-2xl">
//         <i className="fas fa-star"></i>
//       </div>
//       <div className="floating-particle particle-2 text-white text-opacity-30 text-xl">
//         <i className="fas fa-circle"></i>
//       </div>
//       <div className="floating-particle particle-3 text-white text-opacity-30 text-3xl">
//         <i className="fas fa-triangle"></i>
//       </div>
//       <div className="floating-particle particle-4 text-white text-opacity-30 text-2xl">
//         <i className="fas fa-square"></i>
//       </div>
//       <div className="floating-particle particle-5 text-white text-opacity-30 text-xl">
//         <i className="fas fa-heart"></i>
//       </div>
//       <div className="floating-particle particle-6 text-white text-opacity-30 text-2xl">
//         <i className="fas fa-diamond"></i>
//       </div>

//       {/* Floating Participants in Safe Zones */}

//       {/* Header */}
//       <header className="p-4 md:p-6 relative z-30">
//         <div className="header-card rounded-2xl px-4 py-4 flex items-center justify-between">
//           <div className="flex items-center space-x-4">
// <div className="text-3xl md:text-4xl flex items-center justify-center w-16 h-16 rounded-full bg-white bg-opacity-20">
//   {logo ? (
//     <img
//       src={logo}
//       alt="Game Logo"
//       className="object-contain rounded-full"
//       style={{ background: 'transparent' }}
//     />
//   ) : (
//     <i className="fas fa-film text-white"></i>
//   )}
// </div>
//             <div>
//               <h1 className="text-white text-xl md:text-2xl font-bold">{gameName}</h1>
//               {/* <p className="text-white text-opacity-70 text-sm">Trivia Challenge</p> */}
//             </div>
//           </div>
//           <div className="participant-counter info-card rounded-xl px-4 py-2 md:px-6 md:py-3" onClick={toggleParticipantsList}>
//             <div className="flex items-center space-x-2">
//               <i className="fas fa-users text-white text-lg"></i>
//               <span className="text-white font-semibold text-sm md:text-base">
//                 <span id="participant-count">{participants.length}</span> Players
//               </span>
//               <i className="fas fa-chevron-down text-white text-sm"></i>
//             </div>
//           </div>
//         </div>
//       </header>

//       {/* Main Content */}
//       <main className="main-content relative z-20">
//        <div className="content-section" ref={contentSectionRef}>
//              {/* <div className="participant-zones">
//   <div id="participants-container">
// {participants.map((participant, index) => (
//   <div
//     key={participant.name}
//     className={`participant-badge participant-float rounded-2xl px-3 py-2 participant-zone ${participantZones[index % participantZones.length]} pointer-events-auto cursor-pointer`}
//     style={{
//                 position: 'absolute',
//           left: positions[index]?.left || '10%',
//           top: positions[index]?.top || '10%',
//       animationDelay: `${index * 1.5}s`,
//       transition: 'transform 0.25s, box-shadow 0.25s, z-index 0s',
//       zIndex: 1
//     }}
//     onMouseEnter={e => {
//       e.currentTarget.style.transform = 'scale(1.15)';
//       e.currentTarget.style.boxShadow = `0 0 24px 0 ${participant.profileColor}`;
//       e.currentTarget.style.zIndex = 10;
//     }}
//     onMouseLeave={e => {
//       e.currentTarget.style.transform = 'scale(1)';
//       e.currentTarget.style.boxShadow = 'none';
//       e.currentTarget.style.zIndex = 1;
//     }}
//   >
//     <div className="flex items-center space-x-2">
//       <div
//         className="w-6 h-6 rounded-full flex items-center justify-center text-white font-bold text-xs"
//         style={{ background: participant.profileColor }}
//       >
//         {participant.initials}
//       </div>
//       <span className="text-white font-semibold text-sm hidden sm:inline">{participant.name}</span>
//       <span className="text-white font-semibold text-sm sm:hidden">{participant.initials}</span>
//     </div>
//   </div>
// ))}
//   </div>
// </div> */}
//           {/* Game Title */}
//           <div className="text-center">
//             <h2 className="game-title text-2xl md:text-4xl lg:text-5xl font-bold mb-2"   style={{ color: 'white' }}>Ready to Play?</h2>
//             <p className="text-white text-opacity-90 text-lg md:text-xl">Join the ultimate trivia experience!</p>
//           </div>

//           {/* QR Code Section */}
//           <div className="relative w-full">
//             {/* Info Button */}


// <div
//   className="qr-container rounded-3xl flex flex-col md:flex-row items-center justify-center w-full max-w-2xl mx-auto py-8 px-6 gap-8 bg-transparent shadow-lg"
//   style={{
//     overflowY: (isMobileDevice() && isLandscapeMode() && window.innerHeight < 450) ? 'auto' : 'visible',
//     maxHeight: (isMobileDevice() && isLandscapeMode() && window.innerHeight < 450) ? '60vh' : 'none',
//   }}
// >
//           {/* <div className="flex items-center justify-center w-full min-w-[220px] min-h-[220px] relative">

//  <div className="bg-white QRContainer"
//   style={{
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     transition: 'transform 0.2s',
//   }}
//   onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.08)'}
//   onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
// >
//   <QRCode
//     className="bg-white QrValue p-1"
//     value={isCLParamPresent ?
//       `https://triviamaker.com/student/${code}` :
//       `https://play.triviamaker.com/hangman/?p=${code}`}
//   />
// </div>
//                 <button
//                   id="lock-btn"

//                 onClick={toggleInstructionsModal}
//                   className="absolute top-2 right-2 bg-white bg-opacity-70 hover:bg-opacity-90 text-gray-800 rounded-full p-2 shadow-lg transition-all duration-200 flex items-center justify-center z-30"
//                   title="How to join"
//                 >
//                   <i id="lock-icon" className="fas fa-info text-lg"></i>
//                 </button>
//               </div> */}
// <div
//   className="flex flex-col items-center justify-center w-full min-w-[220px] min-h-[220px] relative QRContainer"
//   style={{ cursor: 'pointer' }}
// >
//   <div
//     style={{
//       transition: 'transform 0.25s cubic-bezier(.4,2,.6,1)',
//       display: 'inline-block',
//       position: 'relative'  
//     }}
//   >
//     <QRCodeSVG
//    value={isCLParamPresent ?
//       `https://triviamaker.com/student/${code}` :
//       `https://play.triviamaker.com/hangman/?p=${code}`}
//       size={220}
//       onClick={() => setShowQrModal(true)}
//       style={{
//         width: '100%',
//         maxWidth: 400,
//         maxHeight: 400,
//         minWidth: 220,
//         minHeight: 220,
//         display: 'block',
//         margin: 'auto',
//         background: 'transparent'
//       }}
//     />
//     {/* Expand icon button at bottom-right, on top of QR */}
//     <button
//       onClick={() => setShowQrModal(true)}
//        className="absolute bottom-0 right-0 bg-white bg-opacity-70 hover:bg-opacity-90 text-gray-800 rounded-full p-2 shadow-lg transition-all duration-200 flex items-center justify-center z-30"
//     style={{ width: 30, height: 30 }}
//       title="Expand QR Code"
//     >
//       <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
//         <path d="M7 3H3V7" stroke="#222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//         <path d="M13 3H17V7" stroke="#222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//         <path d="M17 13V17H13" stroke="#222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//         <path d="M7 17H3V13" stroke="#222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//       </svg>
//     </button>
//   </div>
//   <button
//     id="lock-btn"
//     onClick={toggleInstructionsModal}
//     className="absolute top-0 right-0 bg-white bg-opacity-70 hover:bg-opacity-90 text-gray-800 rounded-full p-2 shadow-lg transition-all duration-200 flex items-center justify-center z-30"
//     style={{ width: 30, height: 30 }}
//     title="How to join"
//   >
//     <i id="lock-icon" className="fas fa-info text-lg"></i>
//   </button>
// </div>


//               <div className="flex flex-col items-center justify-center w-full md:w-[260px] lg:w-[320px] min-w-[180px]">
//                 {/* <div className="game-code-badge rounded-xl px-6 py-3 mt-2 mb-2 relative z-10 text-center w-full max-w-xs mx-auto">
//                   <p className=" font-semibold text-sm mb-1">Game Code</p>
//                   <p className=" text-2xl md:text-3xl font-bold">{code}</p>
//                 </div> */}
//                                <div className="game-code-badge rounded-xl px-6 py-3 mt-2 mb-2 relative z-10 text-center w-full max-w-xs mx-auto">
//              <p className="text-black font-semibold text-sm mb-2 ml-2" style={{ textAlign: 'left' }}>Game Code</p>
//                   <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', width: '100%' }}>
//                     <p className="text-black text-2xl font-bold" style={{ fontSize: '2.5rem', margin: 0, flex: 1, textAlign: 'left' }}>{code}</p>
//                     <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
//                       <button
//                         onClick={async () => {
//                           await copyToClipboard(code);
//                           setCopySuccess('Copied!');
//                           setTimeout(() => setCopySuccess(''), 1500);
//                         }}
//                         title="Copy Game Code"
//                         style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginLeft: '0.5rem', display: 'flex', alignItems: 'center', position: 'relative' }}
//                       >
//                         <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                           <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
//                           <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
//                         </svg>
//                         {copySuccess && (
//                           <span style={{
//                             position: 'absolute',
//                             top: '-2.2rem',
//                             right: 0,
//                             background: '#222',
//                             color: '#fff',
//                             borderRadius: '6px',
//                             padding: '2px 10px',
//                             fontSize: '0.95rem',
//                             whiteSpace: 'nowrap',
//                             zIndex: 1000,
//                             boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
//                           }}>{copySuccess}</span>
//                         )}
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//                 {/* <a id="join-link" href={`https://play.triviamaker.com/hangman/?p=${code}`} target="_blank" className="block w-full text-center text-base font-semibold text-blue-600 underline mb-2">{`https://play.triviamaker.com/hangman/?p=${code}`}</a> */}
//                 {/* <p id="join-caption" className="text-center text-sm md:text-base  relative z-10 w-full max-w-xs mx-auto">Scan QR code or visit   <a id="join-link" href={`https://play.triviamaker.com/hangman/?p=${code}`} target="_blank" className="block w-full text-center text-base font-semibold text-blue-600 underline mb-2">{`https://play.triviamaker.com/hangman/?p=${code}`}</a>to join</p> */}
//               <p id="join-caption" className="text-center text-sm md:text-base  relative z-10 w-full max-w-xs mx-auto">
//   Scan QR code or visit
//   <a
//     id="join-link"
//     href={`https://play.triviamaker.com/hangman/?p=${code}`}
//     target="_blank"
//     className="block w-full text-center text-base font-semibold underline mb-2"
//     style={{ color: 'black' }} // <-- set link color to black
//   >
//     {`https://play.triviamaker.com/hangman/?p=${code}`}
//   </a>
//   to join
// </p>
//               </div>
//             </div>
//           </div>

//           {/* Start Button */}
//            {/* {participants.length >= 2 && (
//           <button className="start-button text-white font-bold text-xl md:text-2xl px-12 py-4 md:px-16 md:py-5 rounded-2xl hover:scale-105 transition-all duration-300" onClick={handleStart}   style={{ border: '2px solid #fff' }}>

//           {localization.start}
//           </button>
//            )} */}
//             <Box
//   sx={{ position: 'relative', display: 'inline-block' }}
//   onMouseEnter={() => setShowStartTooltip(participants.length < 2)}
//   onMouseLeave={() => setShowStartTooltip(false)}
// >
//   <button
//  className="start-button text-white font-bold text-xl md:text-2xl px-12 py-4 md:px-16 md:py-5 rounded-2xl hover:scale-105 transition-all duration-300"

//     disabled={participants.length < 2}
//     style={{ opacity: participants.length < 2 ? 0.3 : 1, border: '2px solid white' }}
//     onClick={handleStart}
//   >
//     <i className="fas fa-play mr-3"></i>
//         {localization.start}
//   </button>
//   {participants.length < 2 && showStartTooltip && (
//     <Box sx={{ ...tooltipStyles }}>
//       Need at least 2 participants to start the game
//     </Box>
//   )}
// </Box>
//         </div>

//             <div className="participant-zones">
//         <div id="participants-container">
// {participants.map((participant, index) => (
//   <div
//         key={participant.key}
//         className="participant-badge participant-float rounded-2xl px-2 py-2 participant-zone pointer-events-auto cursor-pointer"
//         style={{
//           position: 'absolute',
//           left: positions[index]?.left || '10%',
//           top: positions[index]?.top || '10%',
//       animationDelay: `${index * 1.5}s`,
//       zIndex: hoveredParticipant === index ? 2000 : 1000,
//       transform: hoveredParticipant === index ? 'scale(1.25)' : 'scale(1)',
//       transition: 'transform 0.2s, z-index 0.2s',
//       boxShadow: hoveredParticipant === index
//         ? `0 0 20px 5px ${participant.profileColor || '#73ccd1'}`
//         : 'none'
//     }}
//     onMouseEnter={() => {
//       setHoveredParticipant(index);
//       // console.log('Hovered participant:', participant);
//     }}
//     onMouseLeave={() => setHoveredParticipant(null)}
//       >
//     <div className="flex items-center space-x-2">
//       <div
//         className="w-8 h-8 rounded-full flex items-center justify-center font-bold text-xs"
//         style={{
//           background: participant.profileColor || '#ccc',
//           color: 'white',
//           // fontSize: hoveredParticipant === index ? '1.5rem' : '1rem', // Increase initials font size on hover
//           transition: 'font-size 0.2s'
//         }}
//       >
//         {participant.initials}
//       </div>
//       <span
//         className="text-white font-semibold text-sm hidden sm:inline"
//         style={{
//           fontSize: hoveredParticipant === index ? '1.25rem' : '1rem', // Increase name font size on hover
//           transition: 'font-size 0.2s'
//         }}
//       >
//         {participant.name}
//       </span>
//     </div>
//   </div>
// ))}
//         </div>
//       </div>
//       </main>


//       {/* Instructions Modal */}
//       {showInstructions && (
//         <div id="instructions-modal" className="fixed inset-0 bg-black bg-opacity-50 backdrop-filter backdrop-blur-sm z-50" onClick={e => e.target.id === 'instructions-modal' && toggleInstructionsModal()}>
//           <div className="flex items-center justify-center min-h-screen p-4">
//             <div className="instructions-modal rounded-3xl p-8 max-w-md w-full">
//               <div className="flex justify-between items-center mb-6">
//                 <h3 className="text-white text-xl md:text-2xl font-bold">How to Join</h3>
//                 <button onClick={toggleInstructionsModal} className="text-white hover:text-gray-300 transition-colors">
//                   <i className="fas fa-times text-xl"></i>
//                 </button>
//               </div>
//               <div className="space-y-4 text-white text-opacity-90">
//                 <div className="flex items-center space-x-4">
//                   <span className="bg-white bg-opacity-20 rounded-full w-10 h-10 flex items-center justify-center text-lg font-bold text-black">1</span>
//                   <span className="text-base">Scan the QR code with your phone</span>
//                 </div>
//                 <div className="flex items-center space-x-4">
//                   <span className="bg-white bg-opacity-20 rounded-full w-10 h-10 flex items-center justify-center text-lg font-bold text-black">2</span>
//                   <span className="text-base">Enter your name to join the game</span>
//                 </div>
//                 <div className="flex items-center space-x-4">
//                   <span className="bg-white bg-opacity-20 rounded-full w-10 h-10 flex items-center justify-center text-lg font-bold text-black">3</span>
//                   <span className="text-base">Wait for the game to start!</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Participants List Modal */}
//       {showParticipants && (
//         <div id="participants-modal" className="fixed inset-0 bg-black bg-opacity-50 backdrop-filter backdrop-blur-sm z-50" onClick={e => e.target.id === 'participants-modal' && toggleParticipantsList()}>
//           <div className="flex items-center justify-center min-h-screen p-4">
//             <div className="info-card rounded-3xl p-6 max-w-md w-full max-h-96 overflow-hidden">
//               <div className="flex justify-between items-center mb-4">
//                 <h3 className="text-white text-xl font-bold">Connected Players</h3>
//                 <button onClick={toggleParticipantsList} className="text-white hover:text-gray-300">
//                   <i className="fas fa-times text-xl"></i>
//                 </button>
//               </div>
//               <div className="mb-4">
//               <input
//   type="text"
//   placeholder="Search players..."
//   value={searchTerm}
//   onChange={e => setSearchTerm(e.target.value)}
//   className="w-full px-4 py-2 rounded-xl bg-white bg-opacity-20 text-black placeholder-white placeholder-opacity-60 border border-white border-opacity-30 focus:outline-none focus:border-opacity-50"
// />
//         </div>
//               <div className="overflow-y-auto max-h-48 space-y-2">
//                 {filteredParticipants.map((participant, idx) => (
//                   <div key={participant.name + idx} className="flex items-center space-x-3 p-2 rounded-xl bg-white bg-opacity-10">
//                  <div
//   className="w-8 h-8 rounded-full flex items-center justify-center text-white font-bold text-sm"
//   style={{ background: participant.profileColor }}
// >
//   {participant.initials}
// </div>
//                     <span className="text-white">{participant.name}</span>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {showQrModal && (
//   <div
//     style={{
//       position: "fixed",
//       top: 0,
//       left: 0,
//       width: "100vw",
//       height: "100vh",
//       background: "rgba(0,0,0,0.7)",
//       zIndex: 9999,
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center"
//     }}
//     onClick={() => setShowQrModal(false)}
//   >
//     <div
//       style={{
//         background: "#fff",
//         borderRadius: "24px",
//         padding: "32px",
//         boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center"
//       }}
//       onClick={e => e.stopPropagation()}
//     >
//      <QRCodeSVG
//   value={isCLParamPresent ?
//     `https://triviamaker.com/student/${code}` :
//     `https://play.triviamaker.com/hangman/?p=${code}`}
//   size={
//     // For mobile devices, use 90vw or 90vh (whichever is smaller, max 320), else 400
//     (window.innerWidth <= 600 || window.innerHeight <= 500)
//       ? Math.min(window.innerWidth * 0.9, window.innerHeight * 0.9, 250)
//       : 600
//   }
//   style={{
//     width:
//       (window.innerWidth <= 600 || window.innerHeight <= 500)
//         ? Math.min(window.innerWidth * 0.9, window.innerHeight * 0.9, 250)
//         : 600,
//     height:
//       (window.innerWidth <= 600 || window.innerHeight <= 500)
//         ? Math.min(window.innerWidth * 0.9, window.innerHeight * 0.9, 250)
//         : 600,
//     background: "transparent",
//     display: "block",
//     maxWidth: "95vw",
//     maxHeight: "95vh"
//   }}
// />
//     </div>

//     <button
//       onClick={() => setShowQrModal(false)}
//       style={{
//         position: "fixed",
//         top: 30,
//         right: 30,
//         background: "#fff",
//         border: "none",
//         borderRadius: "50%",
//         width: 40,
//         height: 40,
//         fontSize: 24,
//         cursor: "pointer",
//         zIndex: 10000,
//         boxShadow: "0 2px 8px rgba(0,0,0,0.2)"
//       }}
//       aria-label="Close"
//     >
//       &times;
//     </button>
//   </div>
// )}

// {/* {showQrModal && (
//   <div
//     style={{
//       position: "fixed",
//       top: 0,
//       left: 0,
//       width: "100vw",
//       height: "100vh",
//       background: "rgba(0,0,0,0.7)",
//       zIndex: 9999,
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center"
//     }}
//     onClick={() => setShowQrModal(false)}
//   >
//     <div
//       style={{
//         background: "#fff",
//         borderRadius: "24px",
//         padding: "16px",
//         boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         maxWidth: "95vw",
//         maxHeight: "90vh",
//       }}
//       onClick={e => e.stopPropagation()}
//     >
//       <QRCodeSVG
//         value={
//           isCLParamPresent
//             ? `https://triviamaker.com/student/${code}`
//             : `https://play.triviamaker.com/hangman/?p=${code}`
//         }
//         size={
//           // Only reduce QR size for small devices (mobile/tablet)
//           window.innerWidth <= 768 || window.innerHeight <= 500
//             ? Math.min(window.innerWidth * 0.8, window.innerHeight * 0.7, 220)
//             : 320
//         }
//         style={{
//           width:
//             window.innerWidth <= 768 || window.innerHeight <= 500
//               ? Math.min(window.innerWidth * 0.8, window.innerHeight * 0.7, 220)
//               : 320,
//           height:
//             window.innerWidth <= 768 || window.innerHeight <= 500
//               ? Math.min(window.innerWidth * 0.8, window.innerHeight * 0.7, 220)
//               : 320,
//           maxWidth: "80vw",
//           maxHeight: "70vh",
//           background: "transparent",
//           display: "block",
//         }}
//       />
//     </div>
//     <button
//       onClick={() => setShowQrModal(false)}
//       style={{
//         position: "fixed",
//         top: 30,
//         right: 30,
//         background: "#fff",
//         border: "none",
//         borderRadius: "50%",
//         width: 40,
//         height: 40,
//         fontSize: 24,
//         cursor: "pointer",
//         zIndex: 10000,
//         boxShadow: "0 2px 8px rgba(0,0,0,0.2)"
//       }}
//       aria-label="Close"
//     >
//       &times;
//     </button>
//   </div>
// )} */}

//     </div>
// </>
//   )}


//   </>
//   );


// }

import React, { useEffect, useCallback, useState, useRef } from "react";
import { Routes, Route, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useMobileOrientation } from 'react-device-detect';
import "bootstrap/dist/css/bootstrap.min.css";
import { Row, Container, Col, Button, ListGroup, Form } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import QRCode from "react-qr-code";
import { ThreeDot } from "react-loading-indicators";
import "../../style/Host.css";
import { Box, LinearProgress } from "@mui/material";
import noloop from "../../image/musicModal/noloop2.png";
import { setVolume, setPlaying, setLoop, setCode } from '../../Redux/action';
import { ReactComponent as PlayMusicIcon } from "../../image/musicModal/playmusicicon.svg";
import { ReactComponent as StopMusicIcon } from "../../image/stop_music_icon.svg";
import firebase from '../../firebase';
import copy from '../../image/copy.png';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { QRCodeSVG } from 'qrcode.react';
import landscapeIcon from '../../image/landscape-icon.webp';
import '@fortawesome/fontawesome-free/css/all.min.css';
export default function Host({ onNavigate }) {
  const dispatch = useDispatch();
  const { orientation } = useMobileOrientation();
  const backgroundImg = useSelector((state) => state.backgroundImg.backgroundImg);
  const backgroundColor = useSelector((state) => state.backgroundColor.backgroundColor);
  const gameName = useSelector((state) => state.gameName.gameName);
  const logo = useSelector((state) => state.logo.logo);
  const rounds = useSelector((state) => state.round.rounds);
  const teamNames = useSelector(state => state.gameSettings.teamNames);
  const buttonColor = useSelector((state) => state.gameSettings.buttonColor);
  const progress = useSelector((state) => state.audio.progress);
  const volume = useSelector((state) => state.audio.volume);
  const playing = useSelector((state) => state.audio.playing);
  const audio = useSelector((state) => state.audio.audio);
  const loop = useSelector((state) => state.audio.loop);
  const mobile = useSelector(state => state.mobile.isMobile);
  const fontfamily = useSelector((state) => state.gameSettings.fontfamily);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [positions, setPositions] = useState([]);
  const [students, setStudents] = useState([]);
  const [connectedStudent, setconnectedStudent] = useState([]);
  const { clid: clid } = useParams();
  const [copySuccess, setCopySuccess] = useState('');
  const [showQrModal, setShowQrModal] = useState(false);
  const localization = useSelector((state) => state.localization.localization);
  const backgroundStyle = backgroundImg
    ? {
      backgroundImage: `url(${backgroundImg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      paddingLeft: mobile ? '15px' : '0',
      paddingRight: mobile ? '15px' : '0',
    }
    : {
      backgroundColor,
      paddingLeft: mobile ? '15px' : '0',
      paddingRight: mobile ? '15px' : '0',
    };
  const team1bgColor = useSelector(state => state.gameSettings.team1bgColor);
  const team2bgColor = useSelector(state => state.gameSettings.team2bgColor);
  const [code, setCodeState] = useState(null);
  const [codeSet, setCodeSet] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  localStorage.setItem("code", code);
  const [searchTerm, setSearchTerm] = useState("");
  const contentSectionRef = useRef(null);
  const [participants, setParticipants] = useState([]);
  const [locked, setLocked] = useState(true);
  const [showInstructions, setShowInstructions] = useState(false);
  const [showParticipants, setShowParticipants] = useState(false);
  const [connectedStudentsforcrs, setconnectedStudentsforcr] = useState([]);
  const [isportrait, setIsportrait] = useState(false);
  const fullPath = window.location.pathname;
  const isCLParamPresent = fullPath.includes("m=cl");
  const [showStartTooltip, setShowStartTooltip] = useState(false);
  const [hoveredParticipant, setHoveredParticipant] = useState(null);
  const [participantSearch, setParticipantSearch] = useState('');

  const tooltipStyles = {
    position: 'absolute',
    top: '-40px',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: '#222',
    color: '#fff',
    padding: '6px 14px',
    borderRadius: '8px',
    fontSize: '1rem',
    whiteSpace: 'nowrap',
    zIndex: 1000,
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
  };

  const toggleFullscreen = async () => {
    try {
      const element = document.documentElement;
      if (!document.fullscreenElement && !document.webkitFullscreenElement) {
        if (element.requestFullscreen) {
          await element.requestFullscreen();
        } else if (element.webkitRequestFullscreen) {
          await element.webkitRequestFullscreen();
        } else if (element.mozRequestFullScreen) {
          await element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          await element.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          await document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          await document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          await document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          await document.msExitFullscreen();
        }
      }
    } catch (error) {
      console.error('Error toggling fullscreen:', error);
    }
  };

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1200);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1200);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    window.exitgame = async () => {
      console.log("exitgame called on host side (lobby)");
      const userConfirmed = window.confirm("Are you sure you want to exit?");
      if (userConfirmed) {
        if (code) {
          try {
            const db = firebase.database();
            const ref = db.ref(`AppleTV/${code}`);
            await ref.update({
              command: '7020',
              isParticipantGameStarted: false,
            });
            // Wait 3 seconds so participants receive the 7020 command before we delete
            await new Promise(resolve => setTimeout(resolve, 3000));
            await fetch(`https://trivia-maker-tv.firebaseio.com/AppleTV/${code}.json`, { method: 'DELETE' });
          } catch (e) {
            console.error("Error updating database or deleting data:", e);
          }
        }
        
        const keysToRemove = [
          'wordToGuess', 'guessedLetters', 'wrongGuesses', 'currentTeam', 'score',
          'currentScreen', 'roundWinners', 'selectedRound', 'startTime', 'allocatedTeam',
          'allocatedTeamColor', 'currentScreenParticipantside', 'initials', 'name', 'profileColor', 'code'
        ];
        keysToRemove.forEach((key) => window.localStorage.removeItem(key));

        const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
        const isAndroid = /Android/i.test(navigator.userAgent);
        if (isIOS || isAndroid) {
            try {
                window.webkit?.messageHandlers?.nativeProcess?.postMessage("ExitGame");
            } catch (e) {}
        }
        
        setTimeout(() => {
          let id = localStorage.getItem('gameid');
          if (!id) {
            // fallback
            const fullPath = window.location.pathname;
            const parts = fullPath.split('/');
            id = parts[parts.length - 1];
          }
          if (id?.includes("C")) {
            window.location.href = `https://triviamaker.com/corporate-game-preview/game/HM${id}`;
          } else {
            window.location.href = `https://triviamaker.com/game-preview/game/HM${id}`;
          }
        }, 100);
      }
    };
  }, [code]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://trivia-maker-tv.firebaseio.com/AppleTV/${code}.json`
        );
        const data = response.data;
        setData(data);
        setconnectedStudentsforcr(data.teamNames);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (code) {
      fetchData();
    }
  }, [code]);

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape') {
        if (showInstructions) {
          setShowInstructions(false);
        } else if (showParticipants) {
          setShowParticipants(false);
        } else if (showQrModal) {
          setShowQrModal(false);
        }
      }
    };

    document.addEventListener('keydown', handleEscapeKey);

    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [showInstructions, showParticipants, showQrModal]);

  // Track previous participants for toast notification
  const prevParticipantsRef = useRef([]);
  useEffect(() => {
    if (code) {
      const db = firebase.database();
      const ref = db.ref(`AppleTV/${code}`);
      ref.on("value", (snapshot) => {
        const data = snapshot.val();
        const teamParticipants = data !== null && 'teamNames' in data ? data.teamNames.map((team, index) => {
          return {
            initials: team.initials,
            name: team.name,
            profileColor: team.profileColor,
            allocatedTeam: team.allocatedTeam,
          };
        }) : [];

        // Compare with previous participants
        const prev = prevParticipantsRef.current;
        if ((prev.length === 0 && teamParticipants.length > 0) || (prev.length && teamParticipants.length > prev.length)) {
          // Find the new participant(s)
          let newParticipants = [];
          if (prev.length === 0) {
            newParticipants = teamParticipants;
          } else {
            newParticipants = teamParticipants.filter(
              p => !prev.some(prevP => prevP.name === p.name)
            );
          }
          newParticipants.forEach(p => {
            toast.success(
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <div
                  style={{
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    backgroundColor: p.profileColor || '#808080',
                    color: p.initialColor || '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.75rem',
                    fontWeight: 'bold'
                  }}
                >
                  {p.initials}
                </div>
                <span><strong>{p.name}</strong> connected!</span>
              </div>,
              {
                position: "bottom-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              }
            );
          });
        }
        prevParticipantsRef.current = teamParticipants;
        setParticipants(teamParticipants);
      });
    }
  }, [code]);

  useEffect(() => {
    if (orientation === 'portrait') {
      setIsportrait(true);
      console.log("Mobile portrait mode detected");
    } else {
      setIsportrait(false);
      console.log("Not mobile portrait mode");
    }
  }, [orientation]);

  const filteredParticipants = participants.filter(
    participant =>
      participant.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      participant.initials.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const generateRandomPositions = (count, avoidRect) => {
    const positions = [];
    const containerWidth = window.innerWidth;
    const containerHeight = window.innerHeight;

    const isOverlapping = (x, y) => {
      const overlapBubble = positions.some(pos => {
        const dx = parseFloat(pos.left) - x;
        const dy = parseFloat(pos.top) - y;
        return Math.sqrt(dx * dx + dy * dy) < 10;
      });
      if (avoidRect) {
        const leftPx = (x / 100) * containerWidth;
        const topPx = (y / 100) * containerHeight;
        if (
          leftPx > avoidRect.left &&
          leftPx < avoidRect.right &&
          topPx > avoidRect.top &&
          topPx < avoidRect.bottom
        ) {
          return true;
        }
      }
      return overlapBubble;
    };

    for (let i = 0; i < count; i++) {
      let x, y, tries = 0;
      do {
        x = Math.random() * 80 + 10;
        y = Math.random() * 70 + 10;
        tries++;
        if (tries > 200) break;
      } while (isOverlapping(x, y));
      positions.push({
        left: `${x}%`,
        top: `${y}%`,
      });
    }
    return positions;
  };

  useEffect(() => {
    if (contentSectionRef.current) {
      const rect = contentSectionRef.current.getBoundingClientRect();
      setPositions(generateRandomPositions(participants.length, rect));
    }
    const handleResize = () => {
      if (contentSectionRef.current) {
        const rect = contentSectionRef.current.getBoundingClientRect();
        setPositions(generateRandomPositions(participants.length, rect));
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [participants.length, contentSectionRef.current]);

  const handleStart = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    let mParam = urlParams.get("m");
    let putData = {};

    if (!mParam) {
      const pathSegments = window.location.pathname.split("/");
      const mSegment = pathSegments.find((segment) => segment.startsWith("m="));
      mParam = mSegment ? mSegment.split("=")[1] : null;
    }

    if (code) {
      try {
        if (mParam === "cl") {
          const clid = window.location.pathname.split("/").pop();
          const timestamp = Date.now();
          const totalQuestions = rounds.length;

          const connectedStudents = participants.map((participant) => {
            return `${participant.initials} ${participant.profileColor} - ${participant.name}&%$@${participant.allocatedTeam}`;
          });

          const currentDataResponse = await axios.get(
            `https://trivia-maker.firebaseio.com/ClassroomLeaderboard/${clid}.json`
          );
          const currentData = currentDataResponse.data || [];

          const currentDataResponseforclassroom = await axios.get(
            `https://trivia-maker.firebaseio.com/Classroom/${clid}.json`
          );
          const currentDataforclassroom = currentDataResponseforclassroom.data || {};

          const initialScores = students.map((student) => ({
            name: student.fullname,
            score: 0,
            correctanswer: 0,
          }));

          const newSession = {
            gametype: "hangman",
            name: gameName,
            date: Math.floor(timestamp / 1000),
            startime: timestamp,
            totalquestions: totalQuestions,
            connectedstudents: connectedStudents,
            scores: initialScores,
            questionsarray: [],
            particiantsanswers: [],
          };

          const newActivity = {
            status: `${gameName} Started`,
            time: timestamp,
          };

          if (currentDataforclassroom.Activities) {
            currentDataforclassroom.Activities.push(newActivity);
          } else {
            currentDataforclassroom.Activities = [newActivity];
          }

          const updatedData = [...currentData, newSession];

          await axios.put(
            `https://trivia-maker.firebaseio.com/ClassroomLeaderboard/${clid}.json`,
            updatedData
          );
          await axios.put(
            `https://trivia-maker.firebaseio.com/Classroom/${clid}.json`,
            currentDataforclassroom
          );

          console.log("Leaderboard data and activity updated successfully.");
        }

        if (mParam === "cr") {
          try {
            const timestamp = Date.now();
            const totalQuestions = rounds.length;

            const connectedStudents = participants.map((participant) => {
              return `${participant.initials} ${participant.profileColor} - ${participant.name}&%$@${participant.allocatedTeam}`;
            });

            const initialScores = participants.map((participant) => ({
              name: `${participant.initials} ${participant.profileColor} - ${participant.name}`,
              score: 0,
              correctanswer: 0,
            }));

            const crowdDataEntry = {
              gametype: "hangman",
              name: gameName,
              date: Math.floor(timestamp / 1000),
              startime: timestamp,
              totalquestions: totalQuestions,
              connectedstudents: connectedStudents,
              scores: initialScores,
              questionsarray: [],
              particiantsanswers: [],
            };

            const gameResponse = await axios.patch(
              `https://trivia-maker-tv.firebaseio.com/AppleTV/${code}.json`,
              {
                isParticipantGameStarted: true,
                crowd: [...(putData.crowd || []), crowdDataEntry],
              }
            );

            if (gameResponse.status === 200) {
              console.log("Crowd data updated successfully.");
            } else {
              console.error("Failed to update crowd data:", gameResponse);
            }
          } catch (error) {
            console.error("Error in setting crowd data:", error);
          }
        }

        onNavigate("splash");
      } catch (error) {
        console.error("Error in handleStart:", error);
      }
    }
  };

  const participantZones = [
    'zone-top-left',
    'zone-top-right',
    'zone-mid-left',
    'zone-mid-right',
    'zone-bottom-left',
    'zone-bottom-right'
  ];

  const toggleInstructionsModal = () => setShowInstructions(v => !v);
  const toggleParticipantsList = () => setShowParticipants(v => !v);
  const toggleLock = () => setLocked(l => !l);

  const formatDate = (date) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}/${mm}/${dd}`;
  };

  const fetchGameData = async () => {
    try {
      const response = await fetch(`https://trivia-maker-tv.firebaseio.com/AppleTV/${code}.json`);
      if (!response.ok) {
        throw new Error(`Error fetching data: ${response.statusText}`);
      }
      const data = await response.json();

      const db = firebase.database();
      const ref = db.ref(`AppleTV/${code}`);

      ref.on('value', snapshot => {
        const data = snapshot.val();
        if (!data) return;

        // Use 'students' for Classroom Mode or 'teamNames' for Crowd Mode
        const participantsData = data.students || data.teamNames;

        if (Array.isArray(participantsData)) {
          const dynamicStudents = participantsData.map((student, index) => {
            // For Crowd Mode, students might be objects with 'name' and 'initials'
            // For Classroom Mode, they might be objects with 'stuname'
            const fullName = student.stuname || student.name || "Unknown";
            const parts = fullName.split(" - ");
            const color = student.profileColor || (parts[0] && parts[0].split(" ")[1]) || "gray";
            const initials = student.initials || (parts[0] && parts[0].split(" ")[0]) || "??";
            const name = parts[1] || fullName.split(" ")[0] || "Unknown";
            const textColor = (color && color.toLowerCase() === "white") ? "black" : "white";
            
            return {
              id: student.stuid || index,
              color: color,
              initials: initials,
              name: name,
              textColor: textColor,
              fullname: fullName,
              correctAnswers: student.correctanswers || 0,
              gamesPlayed: student.gameplayed || 0,
              questionsAttempted: student.questionattempted || 0,
              email: student.stuemail || "N/A",
              stupin: student.stupin || "",
            };
          });

          setStudents(dynamicStudents);
        } else {
          console.error("Invalid or missing participants data:", participantsData);
          setStudents([]);
        }
      });

    } catch (err) {
      console.error("Error fetching game data:", err);
      setError(err.message);
    }
  };

  useEffect(() => {
    fetchGameData();

    return () => {
      const db = firebase.database();
      const ref = db.ref(`AppleTV/${code}/students`);
      ref.off();
    };
  }, [code]);

  let participantLimit = 20;
  let userid = "";

  const generateAndCheckCode = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const currentUrl = window.location.href;
      let randomCode;
      let additionalData = null;
      let crowddata = [];

      if (currentUrl.includes("m=cl")) {
        const idMatch = currentUrl.match(/CL\d+/);
        const dynamicId = idMatch ? idMatch[0] : null;
        console.log(dynamicId, "dynamicId");

        if (dynamicId) {
          const apiResponse = await axios.get(
            `https://trivia-maker.firebaseio.com/Classroom/${dynamicId}.json`
          );
          console.log(apiResponse.data, "apiResponse.data");

          if (apiResponse.data) {
            const slug = apiResponse.data["url-slug"];
            const students = apiResponse.data["students"];
            console.log(students, "Students from API");

            if (slug) {
              randomCode = slug;
              console.log(randomCode, "Random code from url-slug");

              additionalData = {
                students: students || [],
              };
            } else {
              console.error("url-slug is missing or null in the response");
              throw new Error("Invalid API response: missing 'url-slug'");
            }
          } else {
            throw new Error("API response data is null or undefined");
          }
        } else {
          throw new Error("Dynamic ID not found in URL");
        }
      } else {
        randomCode = Math.floor(100000 + Math.random() * 900000);
        console.log(randomCode, "Random code generated");
      }

      try {
        const loginResponse = await fetch("https://triviamaker.com/checklogin.php");
        if (loginResponse.ok) {
          userid = (await loginResponse.text()).trim();
        }

        const defaultDatabase = firebase.initializeApp({
          databaseURL: "https://trivia-maker.firebaseio.com/"
        }, "triviaMakerApp").database();
        const triviaRef = defaultDatabase.ref(`TMUsers/${userid}/Teams`);
        const teamsSnapshot = await triviaRef.once('value');
        const teamsData = teamsSnapshot.val();

        if (teamsData && Array.isArray(teamsData) && teamsData.length > 0) {
          const corporateId = teamsData[0];
          const corpResponse = await fetch(`https://trivia-maker-corporate.firebaseio.com/corporates/${corporateId}/profile/planUserCount.json`);
          const planUserCount = await corpResponse.json();

          if (planUserCount === -1) {
            participantLimit = 200;
          } else if (planUserCount <= 5) {
            participantLimit = 100;
          } else if (planUserCount <= 10) {
            participantLimit = 500;
          } else if (planUserCount <= 20) {
            participantLimit = 1000;
          } else if (planUserCount <= 50) {
            participantLimit = 2000;
          } else if (planUserCount <= 500) {
            participantLimit = 500;
          } else {
            participantLimit = 20;
          }
          console.log("Corporate planUserCount:", planUserCount, "Participant limit set to:", participantLimit);
        } else {
          const subResponse = await axios.get(`https://triviamaker.com/Subscription/checkSubscription.php?userid=${userid}`);
          console.log("Subscription API response:", subResponse.data);

          switch (subResponse.data.type) {
            case "Premium Plus":
              participantLimit = 200;
              break;
            case "Lifetime":
            case "Premium":
              participantLimit = 50;
              break;
            case "null":
            default:
              participantLimit = 20;
              break;
          }
        }
      } catch (error) {
        console.error("Error determining participant limit:", error);
        participantLimit = 20;
      }

      const putData = {
        appStatus: true,
        gameName: gameName,
        gametype: "HangMan",
        logo: logo,
        teams: (Array.isArray(teamNames) && teamNames.length > 0) ? teamNames : ["Team 1", "Team 2"],
        backgroundImg: backgroundImg,
        backgroundColor: backgroundColor,
        team1bgColor: team1bgColor,
        team2bgColor: team2bgColor,
        date: formatDate(new Date()),
        fontfamily: fontfamily,
        participantlimit: participantLimit,
        ...(additionalData ? additionalData : {}),
      };

      console.log("Data to be sent:", putData);

      const putResponse = await axios.put(
        `https://trivia-maker-tv.firebaseio.com/AppleTV/${randomCode}.json`,
        putData
      );

      if (putResponse.status === 200) {
        console.log("Data successfully updated in Firebase");
        dispatch(setCode(randomCode));
        setCodeState(randomCode);
        console.log(randomCode, "Code dispatched to Redux");
      } else {
        console.error("Failed to update data in Firebase", putResponse);
        throw new Error("Failed to save data");
      }
    } catch (error) {
      console.error("Error in generateAndCheckCode:", error);
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (backgroundStyle && !code) {
      generateAndCheckCode();
    }
  }, [gameName, logo, teamNames]);

  const copyToClipboard = async (text) => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
        setCopySuccess('Copied!');
        setTimeout(() => setCopySuccess(''), 2000);
      } else {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);

        if (successful) {
          setCopySuccess('Copied!');
          setTimeout(() => setCopySuccess(''), 2000);
        } else {
          throw new Error('Copy failed');
        }
      }
    } catch (err) {
      console.error('Failed to copy text: ', err);
      setCopySuccess('Copy failed. Please try again.');
      setTimeout(() => setCopySuccess(''), 2000);
    }
  };

  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;

  function getResolution(width, height) {
    if (width >= 3840 && height >= 2160) {
      return "4K";
    } else if (width >= 2560 && height >= 1440) {
      return "2K";
    } else if (width >= 1280 && height >= 720) {
      return "HD";
    } else {
      return "SD";
    }
  }

  function isMobileDevice() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /android|iphone|ipad|ipod/.test(userAgent);
  }

  function isLandscapeMode() {
    return window.innerWidth > window.innerHeight;
  }

  const groupParticipants = (participants, groupSize) => {
    const groups = [];
    for (let i = 0; i < participants.length; i += groupSize) {
      groups.push(participants.slice(i, i + groupSize));
    }
    return groups;
  };

  window.addEventListener("resize", getResolution);
  const resolution = getResolution(screenWidth, screenHeight);

  let groupSize;
  if (isMobileDevice() && isLandscapeMode()) {
    groupSize = 2;
  } else if (resolution === "4K" || resolution === "2K") {
    groupSize = 10;
  } else if (resolution === "HD") {
    groupSize = 10;
  } else {
    groupSize = 6;
  }

  const participantGroups = groupParticipants(participants, groupSize);

  function lightenColor(color, percent) {
    const num = parseInt(color.replace("#", ""), 16);
    const amt = Math.round(2.55 * percent);
    const R = (num >> 16) + amt;
    const G = ((num >> 8) & 0x00ff) + amt;
    const B = (num & 0x0000ff) + amt;

    return (
      "#" +
      (
        0x1000000 +
        (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
        (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
        (B < 255 ? (B < 1 ? 0 : B) : 255)
      )
        .toString(16)
        .slice(1)
    );
  }

  const lighterButtonColor = lightenColor(buttonColor, 30);

  const handleLoopToggle = () => {
    const newLoopState = !loop;
    dispatch(setLoop(newLoopState));
    audio.loop = newLoopState;
  };

  const handlePlay = useCallback(() => {
    console.log("handlePlay called");
    audio?.play();
    dispatch(setPlaying(true));
  }, [audio, dispatch]);

  const handlePause = useCallback(() => {
    console.log("handlePause called");
    if (audio && !audio.paused) {
      audio.pause();
      dispatch(setPlaying(false));
      console.log("Audio paused");
    } else {
      console.log("Audio is already paused or not defined.");
    }
  }, [audio, dispatch]);

  const increaseVolume = () => {
    if (volume < 100) {
      dispatch(setVolume(volume + 10));
    }
  };

  const decreaseVolume = () => {
    if (volume > 0) {
      dispatch(setVolume(volume - 10));
    }
  };

  const handleCopyCode = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(`${code}`)
        .then(() => {
          toast('Code copied to clipboard!');
        })
        .catch((err) => {
          console.error('Failed to copy: ', err);
          toast.error('Failed to copy code.');
        });
    } else {
      fallbackCopyTextToClipboard(code);
    }
  };

  const handleCopyLink = () => {
    const url = isCLParamPresent
      ? `https://triviamaker.com/student/${code}`
      : `https://play.triviamaker.com/hangman/?p=${code}`;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url)
        .then(() => {
          toast('Link copied to clipboard!');
          console.log(`Copied URL: ${url}`);
        })
        .catch((err) => {
          console.error('Failed to copy: ', err);
          toast.error('Failed to copy link.');
        });
    } else {
      fallbackCopyTextToClipboard(url);
    }
  };

  const fallbackCopyTextToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      toast('Link copied to clipboard!');
      console.log(`Copied URL (fallback): ${text}`);
    } catch (err) {
      console.error('Fallback: Failed to copy', err);
      toast.error('Failed to copy text.');
    }
    document.body.removeChild(textArea);
  };

  return (
    <>
      {isportrait ? (
        <>
          <div
            style={{
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
              fontSize: '1.5rem',
              fontWeight: 'bolder',
              backgroundColor: '#27738e',
              color: 'white',
              display: 'flex',
              flexDirection: 'column',
              padding: '1.5vh'
            }}
          >
            <span className='mt-2 mb-4 p-3 '> To view this game, you will need to place your device in landscape mode</span>

            <div style={{ padding: '1.5vh' }}>
              <img src={landscapeIcon} alt="landscapeIcon" height={200} className="rotate-icon" />
            </div>
          </div>
        </>
      ) : (
        <>
          <div
            className="animated-bg relative flex flex-col"
            style={{
              minHeight: '100vh',
              height: '100dvh',
              overflowY: 'auto',
              overflowX: 'hidden',
              WebkitOverflowScrolling: 'touch',
            }}
          >
            {/* Floating Particles */}
            <div className="floating-particle particle-1 text-white text-opacity-30 text-2xl">
              <i className="fas fa-star"></i>
            </div>
            <div className="floating-particle particle-2 text-white text-opacity-30 text-xl">
              <i className="fas fa-circle"></i>
            </div>
            <div className="floating-particle particle-3 text-white text-opacity-30 text-3xl">
              <i className="fas fa-triangle"></i>
            </div>
            <div className="floating-particle particle-4 text-white text-opacity-30 text-2xl">
              <i className="fas fa-square"></i>
            </div>
            <div className="floating-particle particle-5 text-white text-opacity-30 text-xl">
              <i className="fas fa-heart"></i>
            </div>
            <div className="floating-particle particle-6 text-white text-opacity-30 text-2xl">
              <i className="fas fa-diamond"></i>
            </div>

            {/* Header */}
            <header className="p-4 md:p-6 relative z-30">
              <div className="header-card rounded-2xl px-4 py-4 flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="text-3xl md:text-4xl flex items-center justify-center w-16 h-16 rounded-full bg-white bg-opacity-20">
                    {logo ? (
                      <img
                        src={logo}
                        alt="Game Logo"
                        className="object-contain rounded-full"
                        style={{ background: 'transparent' }}
                      />
                    ) : (
                      <i className="fas fa-film text-white"></i>
                    )}
                  </div>
                  <div>
                    <h1 className="text-white text-xl md:text-2xl font-bold">{gameName}</h1>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <button
                    onClick={toggleFullscreen}
                    className="fullscreen-button-host"
                    style={{
                      background: 'rgba(255, 255, 255, 0.15)',
                      border: '1px solid rgba(255, 255, 255, 0.3)',
                      borderRadius: '12px',
                      padding: '10px',
                      cursor: 'pointer',
                      zIndex: 10,
                      transition: 'all 0.3s ease',
                      backdropFilter: 'blur(15px)',
                      WebkitBackdropFilter: 'blur(15px)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '44px',
                      height: '44px',
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                      flexShrink: '0'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.background = 'rgba(255, 255, 255, 0.25)';
                      e.target.style.borderColor = 'rgba(255, 255, 255, 0.4)';
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.15)';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.background = 'rgba(255, 255, 255, 0.15)';
                      e.target.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
                    }}
                  >
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M7 3H3V7" stroke="#ffffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M13 3H17V7" stroke="#ffffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M17 13V17H13" stroke="#ffffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M7 17H3V13" stroke="#ffffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                  <div className="participant-counter info-card rounded-xl px-4 py-2 md:px-6 md:py-3" onClick={toggleParticipantsList}>
                    <div className="flex items-center space-x-2">
                      <i className="fas fa-users text-white text-lg"></i>
                      <span className="text-white font-semibold text-sm md:text-base">
                        <span id="participant-count">{participants.length}</span> Players
                      </span>
                      <i className="fas fa-chevron-down text-white text-sm"></i>
                    </div>
                  </div>
                </div>
              </div>
            </header>

            {/* Main Content */}
            <main
              className="flex-1 flex gap-6 px-4 md:px-6 relative z-20"
              style={{
                minHeight: 0,
                border: '2px solid rgba(255, 255, 255, 0.25)',
                boxShadow: '0 25px 50px rgba(0, 0, 0, 0.15)',
                background: 'rgba(255, 255, 255, 0.15)',
                backdropFilter: 'blur(25px)',
                padding: '1rem',
                maxHeight: '80%',
                borderRadius: '1.5rem',
                margin: '0 1rem 1rem 1rem'
              }}
            >
              {/* Connected Players Sidebar - Hidden on mobile/tablet */}
              {!isSmallScreen && (
                <div
                  className="connected-players-sidebar"
                  style={{
                    width: '28%',
                    minWidth: '280px',
                    maxWidth: '400px',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    background: 'rgba(255, 255, 255, 0.1)',
                    backdropFilter: 'blur(20px)',
                    WebkitBackdropFilter: 'blur(20px)',
                    borderRadius: '24px',
                    padding: '1.5rem',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    overflow: 'hidden'
                  }}
                >
                  <div style={{ marginBottom: '1rem' }}>
                    <h3 className="text-white text-2xl font-bold mb-3">
                      Connected Players ({participants.length})
                    </h3>
                    <input
                      type="text"
                      placeholder="Search players..."
                      className="w-full px-4 py-2 rounded-xl text-white placeholder-white placeholder-opacity-60 border border-white border-opacity-30 focus:outline-none focus:border-opacity-50"
                      style={{
                        background: 'rgba(30, 41, 59, 0.5)',
                        fontSize: '0.9rem',
                        cursor: 'text',
                        caretColor: 'white'
                      }}
                      value={participantSearch}
                      onChange={e => setParticipantSearch(e.target.value)}
                    />
                  </div>

                  <div
                    style={{
                      flex: 1,
                      overflowY: 'auto',
                      overflowX: 'hidden',
                      paddingRight: '0.5rem'
                    }}
                    className="custom-scrollbar"
                  >
                    {participants
                      .filter(participant =>
                        participant.name.toLowerCase().includes(participantSearch.toLowerCase())
                      )
                      .map((participant, idx) => (
                        <div
                          key={participant.key || idx}
                          className="participant-item"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: '0.75rem',
                            borderRadius: '12px',
                            marginBottom: '0.5rem',
                            background: hoveredParticipant === idx
                              ? 'rgba(255, 255, 255, 0.2)'
                              : 'rgba(255, 255, 255, 0.08)',
                            transition: 'all 0.2s ease',
                            cursor: 'pointer',
                            border: '1px solid rgba(255, 255, 255, 0.1)'
                          }}
                          onMouseEnter={() => setHoveredParticipant(idx)}
                          onMouseLeave={() => setHoveredParticipant(null)}
                        >
                          <div
                            className="w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm flex-shrink-0"
                            style={{
                              background: participant.profileColor || '#ccc',
                              color: 'white'
                            }}
                          >
                            {participant.initials}
                          </div>
                          <span
                            className="text-white ml-3 font-semibold"
                            style={{
                              fontSize: '1rem',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            {participant.name} {participant.allocatedTeam ? `(${participant.allocatedTeam})` : ''}
                          </span>
                        </div>
                      ))}

                    {participants.filter(p =>
                      p.name.toLowerCase().includes(participantSearch.toLowerCase())
                    ).length === 0 && (
                        <div className="text-white text-center text-opacity-70 mt-8">
                          {participantSearch ? 'No participants found' : 'Waiting for players to join...'}
                        </div>
                      )}
                  </div>
                </div>
              )}

              {/* RIGHT SIDE - Main Content */}
              <div
                className="content-section content-area"
                ref={contentSectionRef}
                style={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: window.innerWidth < 768 || window.innerHeight < 600 ? 'flex-start' : 'center',
                  padding: '0.5rem',
                  paddingTop: window.innerWidth < 768 || window.innerHeight < 600 ? '2rem' : '0.5rem',
                  position: 'relative',
                  zIndex: 20,
                  overflowY: 'auto',
                  minHeight: 0
                }}
              >
                {/* Title removed per design: no intro heading shown here */}

                <div className="relative " style={{ maxWidth: '1400px', margin: '0 auto' }}>
                  <div
                    className="main-content-card rounded-2xl flex flex-row items-center justify-center w-full mx-auto py-4 px-4 md:py-6 md:px-6 lg:py-8 lg:px-8 bg-transparent shadow-lg gap-4 md:gap-6 lg:gap-8"
                    style={{
                      position: 'relative',
                    }}
                  >
                    {!code ? (
                      <i className="fas fa-circle-notch fa-spin text-white" style={{ fontSize: '3rem', opacity: 0.9 }}></i>
                    ) : (
                      <>
                        <div
                          className="qr-code-container flex flex-col items-center justify-center relative"
                          style={{ cursor: 'pointer', flex: '0 0 auto' }}
                        >
                          <div
                            style={{
                              transition: 'transform 0.25s cubic-bezier(.4,2,.6,1)',
                              display: 'inline-block',
                              position: 'relative',
                              width: '100%'
                            }}
                          >
                            <QRCodeSVG
                              value={isCLParamPresent
                                ? `https://triviamaker.com/student/${code}`
                                : `https://play.triviamaker.com/hangman/?p=${code}`}
                              size={window.innerWidth < 768 ? 220 : window.innerWidth < 1200 ? 260 : 360}
                              onClick={() => setShowQrModal(true)}
                              style={{
                                width: '100%',
                                height: 'auto',
                                maxWidth: window.innerWidth < 768 ? 220 : window.innerWidth < 1200 ? 260 : 360,
                                display: 'block',
                                margin: 'auto',
                                background: 'white',
                                padding: '20px',
                                borderRadius: '20px',
                                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)'
                              }}
                            />
                            <button
                              onClick={() => setShowQrModal(true)}
                              className="qr-expand-button absolute bottom-1.5 right-1.5 bg-white bg-opacity-70 hover:bg-opacity-90 text-gray-800 rounded-full p-1 shadow-lg transition-all duration-200 flex items-center justify-center z-30"
                              style={{ width: 26, height: 26 }}
                              title="Expand QR Code"
                            >
                              <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
                                <path d="M7 3H3V7" stroke="#222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M13 3H17V7" stroke="#222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M17 13V17H13" stroke="#222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M7 17H3V13" stroke="#222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                              </svg>
                            </button>

                            <button
                              id="lock-btn"
                              onClick={toggleInstructionsModal}
                              className="absolute top-1.5 right-1.5 bg-white bg-opacity-70 hover:bg-opacity-90 text-gray-800 rounded-full p-1 shadow-lg transition-all duration-200 flex items-center justify-center z-30"
                              style={{ width: 26, height: 26 }}
                              title="How to join"
                            >
                              <i id="lock-icon" className="fas fa-info text-xs"></i>
                            </button>
                          </div>
                        </div>

                        <div className="game-info-container flex flex-col items-center justify-center flex-1 w-full">
                          <div className="game-code-badge rounded-xl px-4 py-2 md:px-8 md:py-4 mb-2 md:mb-3 relative z-10 text-center  ">
                            <p className="text-black font-semibold text-xs md:text-xl mb-1 md:mb-3" style={{ opacity: 0.7 }}>Game Code</p>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', width: '100%', gap: '0.5rem' }}>
                              {code ? (
                                <>
                                  <p className="text-black font-bold" style={{
                                    fontSize: window.innerWidth < 768 ? '2.5rem' : window.innerWidth < 1200 ? '3rem' : '5rem',
                                    margin: 0,
                                    letterSpacing: '0.12em',
                                    lineHeight: 1,
                                    whiteSpace: 'nowrap'
                                  }}>{code}</p>
                                  <button
                                    onClick={async () => {
                                      await copyToClipboard(code);
                                      setCopySuccess('Code Copied!');
                                      setTimeout(() => setCopySuccess(''), 1500);
                                    }}
                                    title="Copy Game Code"
                                    style={{
                                      background: 'none',
                                      border: 'none',
                                      cursor: 'pointer',
                                      padding: '4px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      position: 'relative',
                                      marginLeft: '0.5rem',
                                      color: '#333',
                                      fontSize: window.innerWidth < 768 || window.innerHeight < 600 ? '1.25rem' : '2rem'
                                    }}
                                  >
                                    <i className="fa-solid fa-copy"></i>
                                    {copySuccess && (
                                      <span style={{
                                        position: 'absolute',
                                        top: '-1.75rem',
                                        right: 0,
                                        background: '#222',
                                        color: '#fff',
                                        borderRadius: '5px',
                                        padding: '3px 8px',
                                        fontSize: '0.75rem',
                                        whiteSpace: 'nowrap',
                                        zIndex: 1000,
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
                                      }}>{copySuccess}</span>
                                    )}
                                  </button>
                                </>
                              ) : (
                                <p className="text-black font-bold animate-pulse" style={{
                                  fontSize: window.innerWidth < 768 ? '1.5rem' : '3rem',
                                  margin: 0,
                                  letterSpacing: '0.05em',
                                  opacity: 0.5
                                }}>Loading...</p>
                              )}
                            </div>
                          </div>

                          {code && (
                            <div className="text-center text-sm md:text-xl text-white text-opacity-85 relative z-10 w-full px-3" style={{ lineHeight: 1.5 }}>
                              <p style={{ margin: 0, marginBottom: '0.5rem' }}>Scan QR code or visit</p>
                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
                                <a
                                  id="join-link"
                                  href={isCLParamPresent
                                    ? `https://triviamaker.com/student/${code}`
                                    : `https://play.triviamaker.com/hangman/?p=${code}`}
                                  target="_blank"
                                  className="text-white font-semibold underline hover:text-opacity-100 transition-all"
                                  style={{ fontSize: window.innerWidth < 768 || window.innerHeight < 600 ? '1rem' : '1.5rem' }}
                                >
                                  {isCLParamPresent
                                    ? `triviamaker.com/student/${code}`
                                    : `play.triviamaker.com/hangman/?p=${code}`}
                                </a>
                                <button
                                  onClick={async () => {
                                    const gameLink = isCLParamPresent
                                      ? `https://triviamaker.com/student/${code}`
                                      : `https://play.triviamaker.com/hangman/?p=${code}`;
                                    await copyToClipboard(gameLink);
                                    setCopySuccess('Link Copied!');
                                    setTimeout(() => setCopySuccess(''), 1500);
                                  }}
                                  title="Copy Game Link"
                                  style={{
                                    background: 'none',
                                    border: 'none',
                                    cursor: 'pointer',
                                    padding: '4px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    color: 'white',
                                    fontSize: window.innerWidth < 768 || window.innerHeight < 600 ? '0.875rem' : '1.25rem'
                                  }}
                                >
                                  <i className="fa-solid fa-copy"></i>
                                </button>
                              </div>
                              <p style={{ margin: 0, marginTop: '0.5rem' }}>to join</p>
                            </div>
                          )}

                          <Box
                            sx={{
                              position: 'relative',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginTop: '1rem'
                            }}
                            onMouseEnter={() => setShowStartTooltip(participants.length < 2)}
                            onMouseLeave={() => setShowStartTooltip(false)}
                          >
                            <button
                              className="start-button text-white font-bold text-xl md:text-2xl px-12 py-4 md:px-16 md:py-5 rounded-2xl hover:scale-105 transition-all duration-300"
                              disabled={participants.length < 2}
                              style={{
                                opacity: participants.length < 2 ? 0.3 : 1,
                                border: '2px solid white',
                                boxShadow: '0 6px 24px rgba(0, 0, 0, 0.3)'
                              }}
                              onClick={handleStart}
                            >
                              <i className="fas fa-play mr-2"></i>
                              {localization.start || 'START GAME'}
                            </button>
                            {participants.length < 2 && showStartTooltip && (
                              <Box sx={{ ...tooltipStyles }}>
                                Need at least 2 participants to start the game
                              </Box>
                            )}
                          </Box>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </main>

            {/* Floating Participants in Safe Zones - Only show when sidebar is hidden */}
            {isSmallScreen && (
              <div className="participant-zones">
                <div id="participants-container">
                  {participants.slice(0, 20).map((participant, index) => (
                    <div
                      key={participant.key}
                      className="participant-badge participant-float rounded-2xl px-2 py-2 participant-zone pointer-events-auto cursor-pointer"
                      style={{
                        position: 'absolute',
                        left: positions[index]?.left || '10%',
                        top: positions[index]?.top || '10%',
                        animationDelay: `${index * 1.5}s`,
                        zIndex: hoveredParticipant === index ? 2000 : 1000,
                        transform: hoveredParticipant === index ? 'scale(1.25)' : 'scale(1)',
                        transition: 'transform 0.2s, z-index 0.2s',
                        boxShadow: hoveredParticipant === index
                          ? `0 0 20px 5px ${participant.profileColor || '#73ccd1'}`
                          : 'none'
                      }}
                      onMouseEnter={() => {
                        setHoveredParticipant(index);
                      }}
                      onMouseLeave={() => setHoveredParticipant(null)}
                    >
                      <div className="flex items-center space-x-2">
                        <div
                          className="w-8 h-8 rounded-full flex items-center justify-center font-bold text-xs"
                          style={{
                            background: participant.profileColor || '#ccc',
                            color: 'white',
                            transition: 'font-size 0.2s'
                          }}
                        >
                          {participant.initials}
                        </div>
                        <span
                          className="text-white font-semibold text-sm hidden sm:inline"
                          style={{
                            fontSize: hoveredParticipant === index ? '1.25rem' : '1rem',
                            transition: 'font-size 0.2s'
                          }}
                        >
                          {participant.name}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Instructions Modal */}
            {showInstructions && (
              <div id="instructions-modal" className="fixed inset-0 bg-black bg-opacity-50 backdrop-filter backdrop-blur-sm z-50" onClick={e => e.target.id === 'instructions-modal' && toggleInstructionsModal()}>
                <div className="flex items-center justify-center min-h-screen p-4">
                  <div className="instructions-modal rounded-3xl p-8 max-w-md w-full">
                    <div className="flex justify-between items-center mb-6">
                      <h3 className="text-white text-xl md:text-2xl font-bold">How to Join</h3>
                      <button onClick={toggleInstructionsModal} className="text-white hover:text-gray-300 transition-colors">
                        <i className="fas fa-times text-xl"></i>
                      </button>
                    </div>
                    <div className="space-y-4 text-white text-opacity-90">
                      <div className="flex items-center space-x-4">
                        <span className="instruction-step-circle">1</span>
                        <span className="text-base">Scan the QR code with your phone</span>
                      </div>
                      <div className="flex items-center space-x-4">
                        <span className="instruction-step-circle">2</span>
                        <span className="text-base">Enter your name to join the game</span>
                      </div>
                      <div className="flex items-center space-x-4">
                        <span className="instruction-step-circle">3</span>
                        <span className="text-base">Wait for the game to start!</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Participants List Modal */}
            {showParticipants && (
              <div id="participants-modal" className="fixed inset-0 bg-black bg-opacity-50 backdrop-filter backdrop-blur-sm z-50" onClick={e => e.target.id === 'participants-modal' && toggleParticipantsList()}>
                <div className="flex items-center justify-center min-h-screen p-4">
                  <div className="participants-modal-card info-card rounded-3xl p-6  overflow-hidden">
                    <div className="flex justify-between items-center mb-4">
                      <h3 className="text-white text-xl font-bold">Connected Players</h3>
                      <button
                        onClick={toggleParticipantsList}
                        className="modal-close-btn text-white hover:text-gray-300 p-2 rounded-full hover:bg-white hover:bg-opacity-10 transition-all"
                        aria-label="Close modal"
                      >
                        <i className="fas fa-times text-xl"></i>
                      </button>
                    </div>
                    <div className="mb-4">
                      <input
                        type="text"
                        placeholder="Search players..."
                        className="w-full px-4 py-2 rounded-xl text-white placeholder-white placeholder-opacity-60 border border-white border-opacity-30 focus:outline-none focus:border-opacity-50"
                        style={{
                          background: 'rgba(30, 41, 59, 0.7)',
                          cursor: 'text',
                          caretColor: 'white'
                        }}
                        value={participantSearch}
                        onChange={e => setParticipantSearch(e.target.value)}
                        autoFocus
                      />
                    </div>
                    <div className="participants-list overflow-y-auto space-y-2">
                      {participants
                        .filter(participant =>
                          participant.name.toLowerCase().includes(participantSearch.toLowerCase())
                        )
                        .map((participant, idx) => (
                          <div key={participant.name + idx} className="flex items-center space-x-3 p-2 rounded-xl bg-white bg-opacity-10">
                            <div
                              className="w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm"
                              style={{
                                background: participant.profileColor || '#ccc',
                                color: 'white'
                              }}
                            >
                              {participant.initials}
                            </div>
                            <span className="text-white ">{participant.name}</span>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {showQrModal && (
              <div
                className="qr-modal-overlay"
                onClick={() => setShowQrModal(false)}
              >
                <div
                  className="qr-modal-content"
                  onClick={e => e.stopPropagation()}
                >
                  <QRCodeSVG
                    value={isCLParamPresent
                      ? `https://triviamaker.com/student/${code}`
                      : `https://play.triviamaker.com/hangman/?p=${code}`}
                    size={
                      window.innerWidth <= 320 ? 200 :
                        window.innerWidth <= 400 ? 240 :
                          window.innerWidth <= 480 ? 260 :
                            window.innerWidth <= 600 ? 280 : 500
                    }
                    className="qr-modal-code"
                  />
                </div>
                <button
                  onClick={() => setShowQrModal(false)}
                  className="qr-modal-close"
                  aria-label="Close QR Code"
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
            )}

            <ToastContainer
              position="bottom-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="dark"
            />
          </div>
        </>
      )}
    </>
  );
}
